var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalad2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_154_1950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1144 7.59893C37.1536 8.14454 36.3209 8.88956 35.7407 9.83009C34.7045 11.5177 33.9289 13.2482 33.3487 14.8971C33.1533 15.4528 33.0495 16.0208 33.027 16.5888C32.9782 17.8815 33.3426 19.1782 34.0001 20.3407C34.053 20.4344 34.0896 20.5341 34.1039 20.6359C34.14 20.8639 34.1851 21.0868 34.2385 21.3048C34.4514 22.1738 33.9349 23.0518 33.065 23.2615C32.1164 23.4903 31.0552 23.6183 29.9347 23.6183C28.696 23.6183 27.53 23.4615 26.5085 23.1854C25.7104 22.9696 25.2062 22.1623 25.3732 21.3527C25.42 21.1258 25.4594 20.8931 25.4906 20.6542C25.515 20.4608 25.6128 20.2775 25.7675 20.1148C26.5329 19.3005 27.1273 18.3375 27.3696 17.2464C27.4286 16.9838 27.4918 16.715 27.5569 16.4423C28.5646 12.3626 30.5556 7.35469 34.4928 3.03887C35.6634 1.75635 37.693 1.77667 38.8514 3.07149C40.1095 4.47403 39.7431 6.67266 38.1144 7.59893Z",
    fill: "url(#paint0_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3444 12.4431H28.8016C28.2742 13.8328 27.8683 15.1819 27.5569 16.4423C27.4918 16.715 27.4287 16.9838 27.3696 17.2464C27.1273 18.3376 26.5329 19.3005 25.7675 20.1148C25.6128 20.2776 25.515 20.4608 25.4906 20.6542C25.4594 20.8931 25.42 21.1258 25.3732 21.3527C25.2062 22.1623 25.7104 22.9696 26.5085 23.1854C27.5301 23.4615 28.696 23.6183 29.9347 23.6183C31.0552 23.6183 32.1164 23.4903 33.065 23.2615C33.9349 23.0518 34.4514 22.1738 34.2385 21.3048C34.1851 21.0868 34.14 20.8639 34.1039 20.6359C34.0896 20.5342 34.053 20.4344 34.0001 20.3407C33.3426 19.1783 32.9781 17.8815 33.027 16.5888C33.0494 16.0208 33.1532 15.4528 33.3487 14.8971C33.6313 14.0937 33.9613 13.2708 34.3444 12.4431Z",
    fill: "url(#paint1_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.953759 18.9476C1.75268 18.68 2.67974 18.5672 3.65806 18.6391C2.4727 18.1979 1.36577 17.6894 1.00727 17.4688C0.174559 16.9565 -0.0852065 15.8662 0.427098 15.0335C0.939403 14.2008 2.02974 13.9411 2.86245 14.4533C3.24487 14.6886 4.30347 15.5361 5.28706 16.4646C5.08061 15.5753 5.04175 14.706 5.15649 13.9236C5.4022 12.2489 7.27075 12.4465 7.99966 14.2198L8.02104 14.2719C8.21392 14.7413 8.28198 15.2456 8.2022 15.6804C8.06235 16.4424 8.07339 17.2959 8.248 18.1751C8.21997 17.4143 8.3311 16.6882 8.56138 16.0449C9.08794 14.5742 10.8844 14.9529 11.2956 16.6174L11.3077 16.6662C11.4165 17.1067 11.397 17.5649 11.2447 17.9451C10.8269 18.9872 10.7306 20.2691 11.0525 21.5722C11.0533 21.5752 11.0541 21.5783 11.0547 21.5813C11.1776 22.0755 11.4076 22.536 11.7072 22.9478C13.1371 24.9129 14.1872 27.0265 14.4401 28.9107C14.4856 29.2498 14.2702 29.5809 13.9362 29.655C13.7854 29.6885 13.6375 29.668 13.5106 29.6076C13.3165 29.5152 13.1715 29.3294 13.1415 29.1004C12.9585 27.71 12.2014 26.0029 11.0123 24.2554C10.6757 23.7608 10.1302 23.4405 9.53335 23.4009C9.53003 23.4007 9.52661 23.4004 9.52329 23.4002C8.18394 23.3135 6.93921 23.6346 5.98716 24.2299C5.63989 24.447 5.19233 24.5471 4.7395 24.5178L4.68931 24.5146C2.97847 24.4037 2.28843 22.7024 3.64302 21.9244C4.2355 21.5841 4.93052 21.3466 5.68433 21.2397C4.78813 21.2231 3.94604 21.363 3.22075 21.6353C2.80688 21.7906 2.29849 21.8127 1.80239 21.7057L1.74741 21.6938C-0.126808 21.2895 -0.651125 19.4852 0.953759 18.9476Z",
    fill: "url(#paint2_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0055 13.0145C6.01312 12.942 6.02152 12.87 6.0307 12.7987C6.69525 12.6476 7.55716 13.1432 7.99935 14.22L8.02123 14.2717C8.21439 14.7411 8.28187 15.2453 8.20267 15.6803C8.06273 16.443 8.07367 17.2959 8.24818 18.1754C8.22054 17.4141 8.33158 16.6884 8.56146 16.0453C9.08812 14.5741 10.8843 14.9529 11.2955 16.6172L11.3079 16.6666C11.4161 17.1065 11.3968 17.5653 11.2446 17.9452C10.8264 18.9872 10.7305 20.2695 11.0525 21.5725C11.0533 21.5751 11.0539 21.5777 11.0546 21.5813C11.1776 22.0752 11.4078 22.5359 11.7076 22.9479C12.6918 24.3012 13.4972 25.7258 13.9851 27.0964C14.2057 27.7155 14.3622 28.3235 14.4405 28.9103C14.483 29.2304 14.2935 29.5433 13.991 29.6397C13.8212 28.4596 12.9439 24.3293 8.70726 20.2601C6.75131 18.3814 5.72347 15.7117 6.0055 13.0145Z",
    fill: "url(#paint3_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.73954 24.5177L4.68935 24.5144C2.97851 24.4036 2.28847 22.7023 3.64306 21.9243C4.23554 21.584 4.93056 21.3465 5.68437 21.2396C4.78818 21.223 3.94608 21.3629 3.22079 21.6352C2.80693 21.7905 2.29853 21.8126 1.80243 21.7056L1.74745 21.6937C-0.126766 21.2894 -0.65118 19.4851 0.9538 18.9476C1.75273 18.68 2.67978 18.5672 3.6581 18.6391C2.47275 18.1978 1.36581 17.6893 1.00732 17.4688C0.174699 16.9565 -0.0850669 15.8662 0.427238 15.0335C0.439835 15.013 0.454386 14.9945 0.467667 14.9747C11.989 19.9036 13.7434 27.917 13.9911 29.6399C13.9732 29.6456 13.9551 29.6509 13.9364 29.655C13.7856 29.6885 13.6377 29.668 13.5108 29.6076C13.3167 29.5152 13.1718 29.3294 13.1417 29.1004C12.9588 27.71 12.2017 26.0029 11.0125 24.2554C10.676 23.7608 10.1305 23.4404 9.53358 23.4009C9.53026 23.4007 9.52685 23.4004 9.52353 23.4002C8.18417 23.3135 6.93944 23.6346 5.98739 24.2299C5.64003 24.447 5.19237 24.5471 4.73954 24.5177Z",
    fill: "url(#paint4_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.73943 24.5177L4.68924 24.5145C2.9784 24.4036 2.28836 22.7023 3.64295 21.9243C4.23543 21.584 4.93045 21.3465 5.68426 21.2397C4.78807 21.2231 3.94598 21.3629 3.22068 21.6352C2.80682 21.7905 2.29842 21.8126 1.80233 21.7056L1.74734 21.6938C0.614337 21.4493 -0.0242372 20.6934 0.00173938 20.0148C1.62166 19.5154 3.14725 19.3472 4.54744 19.3938C7.07801 19.478 9.41365 20.7371 10.9283 22.7661C13.2765 25.9118 13.8563 28.704 13.9909 29.6399C13.9907 29.6402 13.9906 29.6403 13.9904 29.6406C13.8211 29.6928 13.6526 29.6752 13.5105 29.6076C13.3164 29.5152 13.1715 29.3294 13.1414 29.1004C12.9582 27.7082 12.1994 25.9985 11.0077 24.2487C10.6714 23.755 10.1295 23.4399 9.53328 23.4009L9.52322 23.4002C8.18387 23.3135 6.93914 23.6346 5.98709 24.2299C5.63992 24.447 5.19227 24.5471 4.73943 24.5177Z",
    fill: "url(#paint5_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4499 25.1706C13.5529 27.2647 13.8921 28.9527 13.991 29.6399C13.9908 29.6402 13.9907 29.6403 13.9906 29.6406C13.8212 29.6928 13.6528 29.6752 13.5107 29.6076C13.3165 29.5152 13.1716 29.3294 13.1415 29.1004C12.9583 27.7082 12.1996 25.9985 11.0079 24.2487C10.6715 23.755 10.1296 23.4398 9.53344 23.4009L9.52338 23.4002C8.18403 23.3135 6.9393 23.6346 5.98725 24.2299C5.63999 24.447 5.19243 24.5471 4.7396 24.5178L4.6894 24.5146C3.53715 24.4399 2.84917 23.6439 2.93579 22.8943C4.23911 22.1897 5.74565 21.8215 7.33354 21.9002C7.34731 21.9009 7.36108 21.9016 7.37475 21.9023C9.51977 22.0191 11.4489 23.2699 12.4499 25.1706Z",
    fill: "url(#paint6_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.51755 21.0814C9.03903 20.5692 8.77936 19.8852 8.81325 19.1851C8.81345 19.181 8.81364 19.177 8.81384 19.1729C8.88854 17.667 9.27829 16.2824 9.88727 15.1408C10.4826 15.2244 11.0799 15.7436 11.2957 16.6173L11.3081 16.6667C11.4163 17.1066 11.3969 17.5654 11.2447 17.9453C10.8265 18.9873 10.7306 20.2696 11.0526 21.5726C11.0534 21.5752 11.0541 21.5778 11.0548 21.5814C11.1777 22.0753 11.4079 22.536 11.7077 22.948C12.6348 24.2225 13.4018 25.5589 13.896 26.8547C14.1639 27.5573 14.3521 28.2473 14.4406 28.9104C14.4832 29.2304 14.2936 29.5433 13.9911 29.6397C13.8327 28.5391 13.0585 24.8718 9.51755 21.0814Z",
    fill: "url(#paint7_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4775 20.8812C24.4672 20.881 24.4567 20.8807 24.4463 20.8805C24.0682 20.8713 24.0235 20.3304 24.3951 20.2605C24.5426 20.2328 24.6895 20.2091 24.8354 20.1895C25.5023 20.0997 26.2001 19.7632 26.7884 19.2623L26.8535 19.2068C29.0759 17.3146 28.4796 14.5171 25.9399 14.952C25.9271 14.9542 25.9143 14.9564 25.9014 14.9587C24.6671 15.1758 23.7097 13.899 24.2864 12.7862C24.4422 12.4856 24.5584 12.2419 24.6244 12.0771C25.1783 10.6957 24.5074 9.12686 23.1259 8.57295C21.7444 8.01904 20.1756 8.68994 19.6217 10.0715C19.5556 10.2361 19.4713 10.4927 19.3762 10.8177C19.0245 12.0206 17.4503 12.2825 16.7078 11.2728C16.7001 11.2623 16.6924 11.2519 16.6846 11.2414C15.1488 9.17236 12.785 10.7832 13.0848 13.6866L13.0936 13.7718C13.173 14.5402 13.445 15.2656 13.8652 15.7912C13.9571 15.9062 14.0469 16.0248 14.1344 16.1468C14.3549 16.454 13.9489 16.8142 13.6692 16.5597C13.6615 16.5526 13.6538 16.5457 13.6461 16.5387C11.8805 14.9455 9.74401 16.7474 10.3914 19.2758L10.4103 19.3499C10.5817 20.0191 10.9379 20.6197 11.416 21.0197C12.7269 22.1165 13.7794 23.7664 14.2862 25.7458C14.5605 26.8171 14.648 27.8801 14.5726 28.8829C14.8634 28.6041 15.2621 28.7639 15.2797 29.1664C15.9179 28.3893 16.7155 27.6811 17.6539 27.096C19.3877 26.0149 21.2884 25.549 22.9939 25.6616C23.616 25.7027 24.2884 25.5145 24.8746 25.149L24.9395 25.1085C27.1547 23.7278 26.8547 20.949 24.4775 20.8812Z",
    fill: "url(#paint8_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2798 29.1665C15.9181 28.3893 16.7157 27.6811 17.6541 27.0961C19.3878 26.015 21.2886 25.5491 22.9941 25.6617C23.6162 25.7028 24.2885 25.5146 24.8748 25.1491L24.9397 25.1086C27.1544 23.7277 26.8544 20.9489 24.4773 20.8811C24.4668 20.8809 24.4565 20.8806 24.446 20.8804C24.068 20.8712 24.0233 20.3303 24.3949 20.2604C24.5424 20.2327 24.6893 20.209 24.8352 20.1893C25.5021 20.0996 26.1999 19.7631 26.7881 19.2622L26.8533 19.2067C29.0757 17.3145 28.4793 14.517 25.9397 14.9519C25.9269 14.9541 25.9141 14.9563 25.9012 14.9586C24.6668 15.1757 23.7095 13.8989 24.2863 12.7861C24.442 12.4855 24.5583 12.2418 24.6243 12.077C25.1782 10.6956 24.5072 9.12675 23.1257 8.57285L15.0286 28.7691C15.1669 28.8247 15.271 28.9653 15.2798 29.1665Z",
    fill: "url(#paint9_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6542 27.0961C19.3879 26.015 21.2887 25.5491 22.9942 25.6617C23.6163 25.7028 24.2886 25.5147 24.8749 25.1491L24.9398 25.1086C27.1545 23.7277 26.8545 20.9489 24.4774 20.8812C24.4669 20.8809 24.4566 20.8806 24.4461 20.8804C24.0681 20.8712 24.0234 20.3303 24.395 20.2605C24.5425 20.2327 24.6894 20.209 24.8353 20.1894C25.5022 20.0996 26.1999 19.7631 26.7882 19.2622L26.8534 19.2067C27.623 18.5515 28.0541 17.7877 28.1839 17.0871C23.2875 16.832 20.0372 18.6551 18.7077 19.5928L15.0286 28.7692C15.1667 28.8246 15.2708 28.9652 15.2796 29.1665C15.9182 28.3894 16.7158 27.6813 17.6542 27.0961Z",
    fill: "url(#paint10_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.28 29.1665C15.9183 28.3894 16.7158 27.6812 17.6542 27.0961C19.388 26.015 21.2888 25.5491 22.9942 25.6617C23.6163 25.7028 24.2887 25.5147 24.8749 25.1491L24.9398 25.1086C26.1028 24.3835 26.5713 23.2732 26.4108 22.3722C21.5422 22.1085 17.7337 24.2005 16.5163 25.0591L15.0288 28.7692C15.1671 28.8247 15.2712 28.9653 15.28 29.1665Z",
    fill: "url(#paint11_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.28 29.1665C15.9183 28.3894 16.7158 27.6812 17.6542 27.0961C19.388 26.015 21.2888 25.5491 22.9942 25.6617C23.6163 25.7028 24.2887 25.5147 24.8749 25.1491L24.9398 25.1086C26.1028 24.3835 26.5713 23.2732 26.4108 22.3722C21.5422 22.1085 17.7337 24.2005 16.5163 25.0591L15.0288 28.7692C15.1671 28.8247 15.2712 28.9653 15.28 29.1665Z",
    fill: "url(#paint12_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2865 25.7459C13.7797 23.7665 12.7274 22.1166 11.4163 21.0198C10.9382 20.6198 10.582 20.0192 10.4107 19.35L10.3916 19.2759C9.74426 16.7475 11.8808 14.9456 13.6463 16.5388C13.654 16.5457 13.6617 16.5527 13.6695 16.5598C13.9491 16.8143 14.3551 16.4541 14.1347 16.1469C14.0472 16.0248 13.9573 15.9062 13.8655 15.7913C13.4452 15.2657 13.1733 14.5403 13.0939 13.7719L13.0851 13.6867C12.9813 12.6812 13.1972 11.8312 13.5872 11.235C17.3036 14.433 18.3945 17.9966 18.7079 19.593L15.0288 28.7694C14.8906 28.7141 14.7183 28.7437 14.5729 28.8832C14.6484 27.8802 14.5609 26.8172 14.2865 25.7459Z",
    fill: "url(#paint13_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5729 28.883C14.6483 27.8802 14.5608 26.8172 14.2865 25.7459C13.7796 23.7665 12.7273 22.1166 11.4163 21.0198C10.9381 20.6198 10.5819 20.0192 10.4106 19.35L10.3915 19.2759C10.0516 17.9481 10.4798 16.8218 11.2184 16.2811C14.9207 19.4539 16.2292 23.5974 16.5164 25.0591L15.0289 28.7692C14.8907 28.7139 14.7183 28.7436 14.5729 28.883Z",
    fill: "url(#paint14_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4035 22.6828C23.3871 22.4328 23.1724 22.2441 22.9211 22.2599C21.1273 22.3775 18.7544 23.214 16.7714 24.4235L16.1653 25.9355C16.7135 25.5217 17.3407 25.123 18.0281 24.7566C19.7251 23.8522 21.5765 23.2572 22.9805 23.1651C23.2304 23.1487 23.4199 22.9328 23.4035 22.6828Z",
    fill: "url(#paint15_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4035 22.6828C23.3871 22.4328 23.1724 22.2441 22.9211 22.2599C21.1273 22.3775 18.7544 23.214 16.7714 24.4235L16.1653 25.9355C16.7135 25.5217 17.3407 25.123 18.0281 24.7566C19.7251 23.8522 21.5765 23.2572 22.9805 23.1651C23.2304 23.1487 23.4199 22.9328 23.4035 22.6828Z",
    fill: "url(#paint16_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6049 17.1921C25.5885 16.9421 25.3738 16.7534 25.1226 16.7691C23.3287 16.8867 20.9559 17.7233 18.9729 18.9328L18.3667 20.4447C18.9149 20.031 19.5421 19.6322 20.2295 19.2658C21.9266 18.3614 23.7779 17.7665 25.1819 17.6744C25.4318 17.658 25.6213 17.4421 25.6049 17.1921Z",
    fill: "url(#paint17_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6049 17.1921C25.5885 16.9421 25.3738 16.7534 25.1226 16.7691C23.3287 16.8867 20.9559 17.7233 18.9729 18.9328L18.3667 20.4447C18.9149 20.031 19.5421 19.6322 20.2295 19.2658C21.9266 18.3614 23.7779 17.7665 25.1819 17.6744C25.4318 17.658 25.6213 17.4421 25.6049 17.1921Z",
    fill: "url(#paint18_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1786 18.5835C13.3631 18.4141 13.6486 18.4259 13.8195 18.6108C15.0353 19.9351 16.1731 22.1791 16.7713 24.4235L16.1651 25.9355C16.0545 25.2575 15.8765 24.536 15.6327 23.7963C15.0304 21.97 14.1028 20.2609 13.1512 19.2244C12.9818 19.0398 12.994 18.7529 13.1786 18.5835Z",
    fill: "url(#paint19_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.38 13.0927C15.5646 12.9233 15.85 12.9351 16.0209 13.12C17.2367 14.4442 18.3745 16.6883 18.9727 18.9327L18.3665 20.4446C18.2559 19.7667 18.0779 19.0452 17.8341 18.3055C17.2318 16.4792 16.3042 14.7701 15.3526 13.7336C15.1832 13.5491 15.1954 13.2621 15.38 13.0927Z",
    fill: "url(#paint20_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9507 33.9532C12.5253 33.7827 12.3187 33.2996 12.4892 32.8742L19.7527 14.7574C19.9232 14.332 20.4063 14.1255 20.8317 14.296C21.2571 14.4665 21.4637 14.9496 21.2932 15.375L14.0297 33.4918C13.8591 33.9172 13.3761 34.1238 12.9507 33.9532Z",
    fill: "url(#paint21_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9965 24.1264L12.4892 32.8742C12.3187 33.2996 12.5253 33.7827 12.9507 33.9532C13.3761 34.1237 13.8592 33.9172 14.0297 33.4918L17.5369 24.744L15.9965 24.1264Z",
    fill: "url(#paint22_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8073 24.6328L36.8554 24.6721C37.2887 25.0261 37.8095 25.2465 38.3134 25.2776C39.6951 25.3627 41.174 25.9328 42.4556 26.9799C43.1491 27.5466 43.7169 28.1976 44.1496 28.8877C44.2053 28.5662 44.542 28.4788 44.7469 28.7328C44.7896 27.9194 44.9693 27.0745 45.3001 26.2421C45.9111 24.7042 46.9265 23.4871 48.0927 22.7411C48.518 22.4691 48.866 22.0233 49.0725 21.5033L49.0954 21.4457C49.876 19.4812 48.3451 17.8136 46.7627 18.9116C46.7557 18.9164 46.7488 18.9213 46.742 18.9261C46.4911 19.1017 46.202 18.7705 46.4107 18.5464C46.4936 18.4573 46.578 18.3714 46.6637 18.2885C47.0554 17.9095 47.3486 17.3548 47.4915 16.7456L47.5073 16.6781C48.0472 14.3766 46.3142 12.8391 44.8673 14.343C44.8599 14.3506 44.8527 14.3582 44.8454 14.3658C44.1449 15.1005 42.9073 14.7279 42.7486 13.7254C42.7057 13.4545 42.6644 13.2398 42.6283 13.1007C42.3257 11.9339 41.1344 11.2333 39.9676 11.536C38.8008 11.8386 38.1002 13.0298 38.4028 14.1967C38.4389 14.3358 38.5071 14.5436 38.6014 14.8011C38.95 15.7544 38.0494 16.6816 37.0802 16.38C37.0701 16.3769 37.06 16.3737 37.05 16.3707C35.0545 15.7597 34.2873 17.9456 35.8778 19.6946L35.9245 19.7459C36.3455 20.2088 36.8714 20.5511 37.3979 20.6919C37.5131 20.7227 37.6286 20.7569 37.7443 20.7943C38.0356 20.8888 37.944 21.3187 37.6393 21.2871C37.6309 21.2862 37.6225 21.2854 37.6141 21.2846C35.6975 21.094 35.1703 23.2953 36.8073 24.6328Z",
    fill: "url(#paint23_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1497 28.8877C43.717 28.1976 43.1492 27.5466 42.4557 26.9799C41.1741 25.9328 39.6952 25.3627 38.3135 25.2776C37.8095 25.2465 37.2888 25.0261 36.8555 24.6721L36.8074 24.6328C35.1704 23.2953 35.6978 21.094 37.6144 21.2844C37.6228 21.2852 37.6312 21.286 37.6396 21.2869C37.9441 21.3185 38.0358 20.8886 37.7445 20.7942C37.6288 20.7567 37.5133 20.7225 37.3982 20.6916C36.8716 20.5508 36.3457 20.2086 35.9247 19.7456L35.878 19.6944C34.2875 17.9453 35.0548 15.7594 37.0502 16.3704C37.0603 16.3735 37.0703 16.3766 37.0804 16.3797C38.0496 16.6813 38.9502 15.7542 38.6016 14.8008C38.5073 14.5433 38.4392 14.3355 38.403 14.1964C38.1004 13.0296 38.801 11.8383 39.9678 11.5357L44.3924 28.5944C44.2756 28.6247 44.1775 28.7269 44.1497 28.8877Z",
    fill: "url(#paint24_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4556 26.9799C41.174 25.9328 39.6951 25.3627 38.3134 25.2776C37.8094 25.2465 37.2887 25.0261 36.8554 24.6721L36.8073 24.6328C35.1703 23.2953 35.6977 21.094 37.6143 21.2844C37.6227 21.2852 37.6311 21.2861 37.6395 21.2869C37.944 21.3185 38.0357 20.8886 37.7444 20.7942C37.6287 20.7567 37.5132 20.7225 37.398 20.6916C36.8715 20.5508 36.3456 20.2086 35.9246 19.7456L35.8779 19.6944C35.3271 19.0887 35.0595 18.4307 35.0273 17.8545C38.9871 18.154 41.4105 19.9533 42.3819 20.8435L44.3923 28.5944C44.2756 28.6246 44.1774 28.7269 44.1496 28.8876C43.7169 28.1976 43.1491 27.5465 42.4556 26.9799Z",
    fill: "url(#paint25_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1495 28.8877C43.7168 28.1976 43.1491 27.5466 42.4555 26.9799C41.174 25.9328 39.695 25.3627 38.3133 25.2776C37.8093 25.2465 37.2886 25.0261 36.8553 24.6721L36.8073 24.6328C35.9477 23.9305 35.6857 22.9904 35.9075 22.2829C39.8458 22.5727 42.6899 24.6454 43.5794 25.4607L44.3922 28.5945C44.2754 28.6247 44.1774 28.7269 44.1495 28.8877Z",
    fill: "url(#paint26_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1495 28.8877C43.7168 28.1976 43.1491 27.5466 42.4555 26.9799C41.174 25.9328 39.695 25.3627 38.3133 25.2776C37.8093 25.2465 37.2886 25.0261 36.8553 24.6721L36.8073 24.6328C35.9477 23.9305 35.6857 22.9904 35.9075 22.2829C39.8458 22.5727 42.6899 24.6454 43.5794 25.4607L44.3922 28.5945C44.2754 28.6247 44.1774 28.7269 44.1495 28.8877Z",
    fill: "url(#paint27_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3001 26.2421C45.9111 24.7042 46.9266 23.4871 48.0927 22.7411C48.518 22.4691 48.866 22.0233 49.0726 21.5033L49.0954 21.4457C49.876 19.4812 48.3451 17.8136 46.7627 18.9116C46.7558 18.9164 46.7488 18.9213 46.742 18.9261C46.4911 19.1017 46.202 18.7706 46.4107 18.5464C46.4937 18.4573 46.578 18.3714 46.6637 18.2885C47.0554 17.9095 47.3486 17.3548 47.4915 16.7456L47.5073 16.6781C47.6943 15.8811 47.6084 15.176 47.3564 14.6568C44.0414 16.8432 42.798 19.5936 42.3818 20.8438L44.3922 28.5946C44.5089 28.5644 44.6443 28.606 44.7468 28.733C44.7896 27.9193 44.9693 27.0744 45.3001 26.2421Z",
    fill: "url(#paint28_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7468 28.7327C44.7896 27.9194 44.9694 27.0744 45.3 26.242C45.9111 24.7041 46.9265 23.487 48.0926 22.741C48.5179 22.469 48.866 22.0232 49.0725 21.5032L49.0954 21.4456C49.5052 20.414 49.2772 19.4651 48.7396 18.9546C45.4385 21.1221 43.9605 24.3159 43.5793 25.4607L44.3921 28.5944C44.5089 28.5642 44.6444 28.6058 44.7468 28.7327Z",
    fill: "url(#paint29_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2915 22.8423C38.3305 22.6432 38.5223 22.5137 38.7226 22.5522C40.1516 22.8315 41.9716 23.7479 43.4401 24.9239L43.7713 26.2009C43.3735 25.812 42.9108 25.4271 42.3963 25.0619C41.1262 24.1606 39.7001 23.4919 38.5817 23.2734C38.3826 23.2344 38.2527 23.0414 38.2915 22.8423Z",
    fill: "url(#paint30_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2915 22.8423C38.3305 22.6432 38.5223 22.5137 38.7226 22.5522C40.1516 22.8315 41.9716 23.7479 43.4401 24.9239L43.7713 26.2009C43.3735 25.812 42.9108 25.4271 42.3963 25.0619C41.1262 24.1606 39.7001 23.4919 38.5817 23.2734C38.3826 23.2344 38.2527 23.0414 38.2915 22.8423Z",
    fill: "url(#paint31_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0887 18.2045C37.1277 18.0054 37.3195 17.8759 37.5197 17.9144C38.9488 18.1937 40.7688 19.1101 42.2372 20.2861L42.5685 21.5631C42.1706 21.1742 41.7079 20.7893 41.1935 20.4241C39.9234 19.5228 38.4973 18.8541 37.3788 18.6356C37.1796 18.5967 37.0497 18.4037 37.0887 18.2045Z",
    fill: "url(#paint32_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0887 18.2045C37.1277 18.0054 37.3195 17.8759 37.5197 17.9144C38.9488 18.1937 40.7688 19.1101 42.2372 20.2861L42.5685 21.5631C42.1706 21.1742 41.7079 20.7893 41.1935 20.4241C39.9234 19.5228 38.4973 18.8541 37.3788 18.6356C37.1796 18.5967 37.0497 18.4037 37.0887 18.2045Z",
    fill: "url(#paint33_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9279 20.6023C46.797 20.4472 46.5665 20.4273 46.4102 20.5582C45.2971 21.4968 44.1519 23.1824 43.4402 24.9239L43.7714 26.2009C43.9301 25.6677 44.1474 25.1064 44.4196 24.5372C45.0915 23.1322 46.0127 21.8547 46.8839 21.12C47.039 20.9892 47.0587 20.7573 46.9279 20.6023Z",
    fill: "url(#paint34_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.725 15.9645C45.5941 15.8094 45.3636 15.7895 45.2073 15.9204C44.0942 16.859 42.949 18.5445 42.2373 20.2861L42.5686 21.5631C42.7272 21.0299 42.9445 20.4686 43.2167 19.8994C43.8886 18.4944 44.8099 17.2169 45.6811 16.4822C45.836 16.3515 45.8558 16.1196 45.725 15.9645Z",
    fill: "url(#paint35_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5278 32.9731C45.8871 32.8799 46.1028 32.513 46.0097 32.1537L42.0406 16.8514C41.9475 16.4921 41.5807 16.2764 41.2213 16.3695C40.862 16.4627 40.6463 16.8295 40.7395 17.1889L44.7085 32.4912C44.8018 32.8505 45.1686 33.0662 45.5278 32.9731Z",
    fill: "url(#paint36_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0932 24.7649L46.0097 32.1537C46.1028 32.513 45.8871 32.8798 45.5278 32.9731C45.1686 33.0662 44.8018 32.8505 44.7085 32.4912L42.792 25.1024L44.0932 24.7649Z",
    fill: "url(#paint37_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.39385 22.5503C1.51943 22.5503 0 24.0697 0 25.9441C0 27.8184 1.51943 29.3378 3.39375 29.3378C5.26807 29.3378 6.7875 27.8184 6.7875 25.9441C6.7875 24.0697 5.26816 22.5503 3.39385 22.5503ZM3.39385 27.2494C2.67295 27.2494 2.08857 26.6651 2.08857 25.9442C2.08857 25.2233 2.67295 24.6389 3.39385 24.6389C4.11475 24.6389 4.69912 25.2233 4.69912 25.9442C4.69912 26.6651 4.11475 27.2494 3.39385 27.2494Z",
    fill: "url(#paint38_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 25.9441C0 27.8184 1.51943 29.3378 3.39385 29.3378C5.26826 29.3378 6.7877 27.8184 6.7877 25.9441C6.7877 25.315 6.61582 24.7262 6.31748 24.221H0.470215C0.171875 24.7262 0 25.315 0 25.9441ZM3.39385 24.6388C4.11475 24.6388 4.69912 25.2232 4.69912 25.9441C4.69912 26.665 4.11475 27.2493 3.39385 27.2493C2.67295 27.2493 2.08857 26.665 2.08857 25.9441C2.08857 25.2232 2.67285 24.6388 3.39385 24.6388Z",
    fill: "url(#paint39_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.994092 28.3439C2.31948 29.6693 4.46831 29.6693 5.7936 28.3439C7.11899 27.0185 7.11899 24.8696 5.7936 23.5443C5.34878 23.0995 4.81099 22.8047 4.24282 22.6585L0.108154 26.7931C0.254443 27.3612 0.54917 27.899 0.994092 28.3439ZM2.47085 25.0211C2.98062 24.5113 3.80708 24.5113 4.31685 25.0211C4.82661 25.5309 4.82661 26.3573 4.31685 26.8671C3.80708 27.3769 2.98062 27.3769 2.47085 26.8671C1.96108 26.3573 1.96108 25.5309 2.47085 25.0211Z",
    fill: "url(#paint40_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5983 12.3863C35.724 12.3863 34.2046 13.9058 34.2046 15.7801C34.2046 17.6544 35.724 19.1738 37.5983 19.1738C39.4727 19.1738 40.9921 17.6544 40.9921 15.7801C40.9921 13.9058 39.4727 12.3863 37.5983 12.3863ZM37.5983 17.0855C36.8774 17.0855 36.2931 16.5011 36.2931 15.7802C36.2931 15.0593 36.8774 14.4749 37.5983 14.4749C38.3192 14.4749 38.9036 15.0593 38.9036 15.7802C38.9036 16.5011 38.3192 17.0855 37.5983 17.0855Z",
    fill: "url(#paint41_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2046 15.7801C34.2046 17.6544 35.724 19.1738 37.5984 19.1738C39.4729 19.1738 40.9923 17.6544 40.9923 15.7801C40.9923 15.151 40.8204 14.5622 40.5221 14.057H34.6748C34.3765 14.5622 34.2046 15.151 34.2046 15.7801ZM37.5984 14.4748C38.3193 14.4748 38.9037 15.0592 38.9037 15.7801C38.9037 16.501 38.3193 17.0854 37.5984 17.0854C36.8775 17.0854 36.2932 16.501 36.2932 15.7801C36.2932 15.0592 36.8775 14.4748 37.5984 14.4748Z",
    fill: "url(#paint42_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1987 18.1799C36.5241 19.5053 38.6729 19.5053 39.9982 18.1799C41.3236 16.8545 41.3236 14.7057 39.9982 13.3804C39.5534 12.9356 39.0156 12.6407 38.4474 12.4945L34.3127 16.6292C34.459 17.1972 34.7539 17.735 35.1987 18.1799ZM36.6754 14.8571C37.1852 14.3474 38.0117 14.3474 38.5214 14.8571C39.0312 15.3669 39.0312 16.1934 38.5214 16.7031C38.0117 17.2129 37.1852 17.2129 36.6754 16.7031C36.1658 16.1934 36.1658 15.3668 36.6754 14.8571Z",
    fill: "url(#paint43_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.05715 19.1017C5.98909 19.6419 6.3719 20.135 6.91204 20.2029C8.71545 20.4301 10.4858 20.981 12.1061 21.8127C12.738 22.1371 13.5 21.7289 13.5888 21.0241C13.6428 20.5954 13.4232 20.178 13.0387 19.9809C11.2073 19.0419 9.20676 18.4202 7.16897 18.1635C6.62874 18.0954 6.13567 18.4782 6.0677 19.0184L6.05715 19.1017Z",
    fill: "url(#paint44_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3702 21.0511L10.6331 18.9638C9.50764 18.5819 8.34456 18.3116 7.16887 18.1635C6.62864 18.0955 6.13557 18.4783 6.0676 19.0184L6.05715 19.1016C5.98909 19.6419 6.3719 20.1349 6.91204 20.2029C8.08987 20.3512 9.25325 20.6385 10.3702 21.0511Z",
    fill: "url(#paint45_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.366 34.4075C11.1076 34.4356 10.8441 34.4491 10.5781 34.4491C6.46211 34.4491 3.12549 31.1125 3.12549 26.9965C3.12549 22.8814 6.46211 19.5447 10.5781 19.5447C10.8441 19.5447 11.1076 19.5583 11.366 19.5863C7.62061 19.9798 4.70205 23.1474 4.70205 26.9965C4.70205 30.8465 7.62061 34.014 11.366 34.4075Z",
    fill: "url(#paint46_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6894 34.4488C15.805 34.4488 19.1414 31.1124 19.1414 26.9968C19.1414 22.8811 15.805 19.5447 11.6894 19.5447C7.5737 19.5447 4.2373 22.8811 4.2373 26.9968C4.2373 31.1124 7.5737 34.4488 11.6894 34.4488Z",
    fill: "url(#paint47_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2373 26.9968C4.2373 31.1124 7.57373 34.4488 11.6894 34.4488C15.805 34.4488 19.1414 31.1124 19.1414 26.9968C19.1414 26.6473 19.1168 26.3035 19.0702 25.9668H4.3085C4.26191 26.3036 4.2373 26.6473 4.2373 26.9968Z",
    fill: "url(#paint48_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1415 26.9968C19.1415 24.0475 17.428 21.4985 14.9422 20.2905L4.98315 30.2497C6.19106 32.7354 8.73999 34.4489 11.6894 34.4489C15.805 34.4488 19.1415 31.1125 19.1415 26.9968Z",
    fill: "url(#paint49_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0688 26.8657L14.9723 26.6589C15.6911 26.6077 16.2713 26.0239 16.2832 25.3034C16.2891 24.9471 16.1598 24.5838 15.8727 24.2966C15.6679 24.0917 15.3599 23.8745 14.9339 23.7765C14.6744 23.7168 14.4742 23.5166 14.4145 23.2571C14.3165 22.8312 14.0993 22.5232 13.8944 22.3183C13.6073 22.0312 13.2439 21.902 12.8876 21.9078C12.1671 21.9198 11.5833 22.4999 11.5321 23.2187L11.3253 26.1222C11.2953 26.5447 11.6465 26.8958 12.0688 26.8657Z",
    fill: "url(#paint50_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.588 27.8715L11.3811 30.775C11.33 31.4938 10.7462 32.0739 10.0257 32.0859C9.66933 32.0918 9.30605 31.9625 9.01884 31.6754C8.81396 31.4705 8.59677 31.1626 8.49873 30.7365C8.43906 30.4772 8.23886 30.2769 7.97939 30.2172C7.55341 30.1192 7.24541 29.902 7.04052 29.6971C6.75341 29.41 6.62421 29.0466 6.63007 28.6903C6.64208 27.9697 7.22216 27.386 7.94091 27.3348L10.8444 27.128C11.267 27.0981 11.6181 27.4491 11.588 27.8715Z",
    fill: "url(#paint51_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7293 27.7302L11.9362 30.6337C11.9874 31.3525 12.5711 31.9326 13.2917 31.9445C13.648 31.9505 14.0113 31.8212 14.2985 31.5341C14.5034 31.3292 14.7206 31.0213 14.8186 30.5952C14.8783 30.3359 15.0785 30.1356 15.3379 30.0759C15.7639 29.9778 16.0719 29.7607 16.2768 29.5558C16.5639 29.2687 16.6931 28.9053 16.6873 28.5489C16.6752 27.8284 16.0952 27.2446 15.3764 27.1935L12.4729 26.9866C12.0503 26.9567 11.6992 27.3077 11.7293 27.7302Z",
    fill: "url(#paint52_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4812 26.9263L7.57764 26.7194C6.85889 26.6683 6.27871 26.0845 6.2668 25.364C6.26084 25.0076 6.39014 24.6444 6.67725 24.3571C6.88213 24.1523 7.19004 23.9351 7.61611 23.837C7.87549 23.7774 8.07578 23.5772 8.13545 23.3177C8.2335 22.8917 8.45069 22.5837 8.65557 22.3788C8.94268 22.0917 9.30606 21.9625 9.6624 21.9684C10.3829 21.9804 10.9667 22.5605 11.0179 23.2792L11.2247 26.1827C11.2546 26.6053 10.9035 26.9565 10.4812 26.9263Z",
    fill: "url(#paint53_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.679 24.2256C13.263 25.0276 12.5165 25.4653 12.0115 25.2034C11.5065 24.9415 11.4345 24.0791 11.8504 23.2771C12.2663 22.475 13.0129 22.0373 13.5179 22.2992C14.0228 22.5611 14.095 23.4235 13.679 24.2256Z",
    fill: "url(#paint54_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1502 30.2851C10.7342 31.087 9.98768 31.5248 9.4827 31.2629C8.97771 31.001 8.90564 30.1386 9.32156 29.3365C9.73758 28.5346 10.4841 28.0968 10.989 28.3587C11.494 28.6206 11.5662 29.4831 11.1502 30.2851Z",
    fill: "url(#paint55_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7384 28.5291C13.2159 28.4853 12.8148 28.1831 12.8424 27.8541C12.87 27.5252 13.3159 27.2941 13.8384 27.3379C14.3609 27.3817 14.762 27.6839 14.7344 28.0129C14.7068 28.3418 14.2609 28.573 13.7384 28.5291Z",
    fill: "url(#paint56_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.504 25.2407C13.8747 24.87 14.3644 24.7587 14.5979 24.9921C14.8313 25.2255 14.72 25.7153 14.3493 26.0861C13.9786 26.4569 13.4889 26.5681 13.2554 26.3347C13.022 26.1012 13.1333 25.6114 13.504 25.2407Z",
    fill: "url(#paint57_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3866 28.8523C7.86414 28.8084 7.46297 28.5063 7.4906 28.1773C7.51824 27.8484 7.96414 27.6172 8.4866 27.6611C9.00906 27.7049 9.41023 28.0071 9.3826 28.3361C9.35496 28.665 8.90906 28.8961 8.3866 28.8523Z",
    fill: "url(#paint58_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4348 26.3015C7.75599 26.2445 7.2347 25.8519 7.27054 25.4244C7.30638 24.997 7.88578 24.6967 8.56458 24.7536C9.24339 24.8106 9.76468 25.2032 9.72884 25.6307C9.693 26.0581 9.11361 26.3584 8.4348 26.3015Z",
    fill: "url(#paint59_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97612 23.9589C9.41372 24.481 10.0349 24.681 10.3636 24.4054C10.6923 24.1298 10.6042 23.4833 10.1666 22.9611C9.72896 22.439 9.10776 22.2391 8.77905 22.5147C8.45034 22.7903 8.53853 23.4368 8.97612 23.9589Z",
    fill: "url(#paint60_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6292 30.4427C13.0668 30.9648 13.688 31.1648 14.0167 30.8892C14.3454 30.6137 14.2572 29.9671 13.8196 29.4449C13.382 28.9229 12.7608 28.7229 12.4321 28.9985C12.1034 29.2739 12.1916 29.9205 12.6292 30.4427Z",
    fill: "url(#paint61_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1729 26.4167C29.5023 25.9067 28.6605 25.5022 27.711 25.256C28.9752 25.2189 30.1868 25.0929 30.5972 24.9992C31.5503 24.7815 32.1465 23.8324 31.9288 22.8792C31.7112 21.9261 30.7619 21.3299 29.8089 21.5476C29.3712 21.6476 28.0965 22.1103 26.8667 22.6737C27.3479 21.8977 27.6639 21.0869 27.8065 20.3092C28.1116 18.6444 26.2786 18.2312 25.0188 19.6766L24.9819 19.719C24.6484 20.1015 24.422 20.5573 24.3579 20.9947C24.2456 21.7612 23.9611 22.566 23.5133 23.3425C23.7842 22.631 23.9122 21.9077 23.9007 21.2245C23.8744 19.6626 22.0515 19.4443 21.1276 20.8885L21.1004 20.9309C20.8559 21.3131 20.7271 21.7534 20.7493 22.1622C20.8103 23.2833 20.4897 24.5283 19.7663 25.6588C19.7647 25.6615 19.7629 25.6642 19.7613 25.6668C19.4862 26.0953 19.1205 26.4577 18.7045 26.7514C16.7193 28.1531 15.0459 29.8173 14.2012 31.5205C14.0491 31.8271 14.1468 32.2097 14.4394 32.3872C14.5714 32.4673 14.7181 32.4955 14.8576 32.4791C15.0712 32.454 15.2681 32.3245 15.3701 32.1173C15.99 30.8593 17.2553 29.4859 18.9427 28.2129C19.4202 27.8527 20.0398 27.7245 20.6177 27.8787C20.6209 27.8796 20.6242 27.8805 20.6275 27.8814C21.9237 28.2294 22.9994 28.9333 23.7098 29.8028C23.9689 30.1199 24.3606 30.3584 24.7989 30.4761L24.8474 30.4892C26.5031 30.9338 27.7031 29.5442 26.6701 28.3723C26.2184 27.8597 25.6364 27.4116 24.9569 27.0683C25.8109 27.3405 26.5634 27.7433 27.1628 28.2341C27.5048 28.5142 27.9792 28.6984 28.4833 28.7564L28.5392 28.7628C30.4441 28.9817 31.5201 27.4413 30.1729 26.4167Z",
    fill: "url(#paint62_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2945 19.1755C27.3106 19.1044 27.3258 19.0336 27.3399 18.9631C26.7592 18.6066 25.7837 18.799 25.019 19.6768L24.9817 19.7187C24.648 20.1012 24.4222 20.5569 24.3575 20.9943C24.245 21.7615 23.9607 22.5658 23.513 23.3427C23.7838 22.6306 23.9116 21.9076 23.9004 21.2248C23.8741 19.6624 22.0514 19.4442 21.1274 20.8882L21.0998 20.9311C20.856 21.3129 20.7269 21.7536 20.7492 22.1623C20.8105 23.2834 20.4894 24.5285 19.7661 25.6591C19.7645 25.6613 19.763 25.6637 19.7612 25.6668C19.4861 26.095 19.1202 26.4574 18.704 26.7512C17.3372 27.7166 16.1169 28.8071 15.2147 29.9483C14.807 30.4638 14.4634 30.9894 14.2009 31.5199C14.0578 31.8093 14.1368 32.1665 14.3923 32.3551C14.932 31.292 17.0895 27.6623 22.4087 25.1694C24.8643 24.0187 26.6952 21.8204 27.2945 19.1755Z",
    fill: "url(#paint63_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.799 30.476L24.8475 30.4891C26.5033 30.9337 27.7032 29.544 26.6703 28.3722C26.2185 27.8596 25.6366 27.4114 24.957 27.0682C25.811 27.3403 26.5635 27.7432 27.1629 28.234C27.5049 28.5141 27.9793 28.6982 28.4834 28.7563L28.5393 28.7627C30.4441 28.9818 31.5202 27.4415 30.1729 26.4169C29.5023 25.9068 28.6605 25.5023 27.711 25.2562C28.9752 25.219 30.1869 25.0931 30.5972 24.9993C31.5503 24.7816 32.1465 23.8325 31.9289 22.8794C31.9235 22.856 31.9157 22.8338 31.9095 22.8107C19.4156 23.778 15.1803 30.8034 14.3923 32.3554C14.4075 32.3665 14.423 32.3772 14.4393 32.3872C14.5713 32.4673 14.718 32.4955 14.8576 32.4791C15.0711 32.454 15.268 32.3245 15.3701 32.1173C15.9899 30.8593 17.2552 29.4858 18.9426 28.2129C19.4202 27.8526 20.0397 27.7244 20.6176 27.8787C20.6208 27.8796 20.6242 27.8805 20.6274 27.8814C21.9236 28.2294 22.9994 28.9333 23.7097 29.8027C23.9689 30.1197 24.3607 30.3583 24.799 30.476Z",
    fill: "url(#paint64_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.799 30.476L24.8475 30.4891C26.5033 30.9337 27.7032 29.5441 26.6703 28.3722C26.2185 27.8596 25.6366 27.4114 24.957 27.0682C25.811 27.3403 26.5635 27.7432 27.1629 28.234C27.5049 28.5141 27.9793 28.6983 28.4834 28.7563L28.5393 28.7627C29.691 28.8952 30.5384 28.3843 30.7318 27.7333C29.3581 26.7401 27.9674 26.0908 26.6264 25.6853C24.2028 24.9524 21.5865 25.3945 19.5004 26.8295C16.2663 29.0543 14.8204 31.5124 14.3923 32.3555C14.3924 32.3558 14.3924 32.356 14.3925 32.3563C14.5361 32.46 14.7013 32.4975 14.8576 32.4791C15.0711 32.454 15.268 32.3245 15.3701 32.1173C15.9907 30.8576 17.2584 29.4823 18.9491 28.208C19.4261 27.8484 20.0406 27.7241 20.6176 27.8786L20.6274 27.8813C21.9236 28.2293 22.9994 28.9332 23.7097 29.8026C23.9689 30.1197 24.3607 30.3583 24.799 30.476Z",
    fill: "url(#paint65_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2872 28.6178C15.5701 30.2466 14.7066 31.7363 14.3923 32.3554C14.3924 32.3557 14.3924 32.3559 14.3925 32.3562C14.5361 32.4599 14.7013 32.4974 14.8576 32.479C15.0711 32.4539 15.268 32.3244 15.3701 32.1172C15.9907 30.8576 17.2584 29.4822 18.949 28.2079C19.426 27.8483 20.0405 27.724 20.6176 27.8785L20.6274 27.8812C21.9236 28.2292 22.9994 28.9331 23.7097 29.8025C23.9688 30.1196 24.3605 30.3582 24.7988 30.4759L24.8473 30.489C25.9625 30.7884 26.8697 30.2556 27.0284 29.5179C26.0205 28.4319 24.712 27.5993 23.183 27.164C23.1697 27.1602 23.1565 27.1564 23.1432 27.1527C21.0744 26.5744 18.8458 27.1394 17.2872 28.6178Z",
    fill: "url(#paint66_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3777 25.6871C21.9953 25.3558 22.461 24.7913 22.6537 24.1174C22.6548 24.1135 22.656 24.1096 22.6571 24.1056C23.07 22.6556 23.1455 21.2191 22.9356 19.9424C22.345 19.8304 21.6126 20.1302 21.1277 20.8883L21.1 20.9312C20.8563 21.313 20.7272 21.7537 20.7494 22.1624C20.8108 23.2835 20.4897 24.5286 19.7663 25.6592C19.7648 25.6614 19.7632 25.6638 19.7615 25.6669C19.4864 26.0951 19.1204 26.4575 18.7042 26.7513C17.4168 27.6604 16.2613 28.6798 15.3771 29.7481C14.8977 30.3274 14.4978 30.9204 14.2011 31.52C14.058 31.8094 14.137 32.1666 14.3925 32.3552C14.8958 31.3637 16.807 28.1394 21.3777 25.6871Z",
    fill: "url(#paint67_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0597 24.8928C17.9163 25.418 18.2258 25.9601 18.751 26.1035C20.5045 26.5824 22.1795 27.3772 23.6665 28.4289C24.2465 28.8391 25.0583 28.5423 25.2455 27.857C25.3593 27.4402 25.2007 26.9961 24.8478 26.7467C23.167 25.5592 21.274 24.6618 19.2927 24.1206C18.7675 23.9772 18.2254 24.2866 18.0819 24.8118L18.0597 24.8928Z",
    fill: "url(#paint68_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0553 27.4304L22.6095 25.401C21.549 24.8644 20.4357 24.433 19.2926 24.1207C18.7674 23.9772 18.2253 24.2867 18.0818 24.8119L18.0597 24.8927C17.9163 25.4179 18.2258 25.96 18.751 26.1035C19.8963 26.4163 21.0075 26.8646 22.0553 27.4304Z",
    fill: "url(#paint69_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.911 31.1782C43.4103 34.679 37.5061 34.451 33.7234 30.6684C29.9408 26.8857 29.7128 20.9814 33.2136 17.4808C34.3438 16.3505 35.7247 15.6089 37.2037 15.2502C39.5347 14.6849 41.838 15.6519 42.9436 17.6324C43.3759 18.4069 43.9246 19.1396 44.5884 19.8035C45.2522 20.4674 45.985 21.016 46.7595 21.4483C48.74 22.5539 49.7071 24.8572 49.1417 27.1882C48.7829 28.6672 48.0414 30.048 46.911 31.1782Z",
    fill: "url(#paint70_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0485 30.5442C43.1123 33.4805 38.0008 33.1299 34.6313 29.7604C31.2619 26.391 30.9113 21.2795 33.8475 18.3433C34.7956 17.3952 35.9703 16.7898 37.2399 16.5182C39.2409 16.0898 41.2578 16.986 42.2653 18.7274C42.6593 19.4084 43.1528 20.0562 43.7441 20.6477C44.3354 21.239 44.9833 21.7325 45.6643 22.1265C47.4058 23.134 48.3019 25.1509 47.8736 27.1518C47.6018 28.4215 46.9966 29.5962 46.0485 30.5442Z",
    fill: "url(#paint71_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2136 17.4808C29.7128 20.9815 29.9408 26.8857 33.7234 30.6684C37.5061 34.451 43.4103 34.679 46.911 31.1782C47.2779 30.8113 47.6032 30.4176 47.8884 30.003L34.3887 16.5033C33.9742 16.7886 33.5805 17.1138 33.2136 17.4808Z",
    fill: "url(#paint72_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5998 23.2485H30.7376C30.6367 25.8615 31.6414 28.5863 33.7235 30.6684C37.5062 34.4511 43.4103 34.679 46.9111 31.1782C48.0413 30.048 48.7829 28.6671 49.1416 27.1881C49.4836 25.7783 49.2642 24.3792 48.5998 23.2485Z",
    fill: "url(#paint73_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4946 21.8229C36.9456 21.3719 37.5107 21.0902 38.1258 20.972C39.0951 20.7856 40.0868 21.2442 40.5966 22.1031C40.6165 22.1368 40.637 22.1702 40.658 22.2035C40.7344 22.3247 40.9024 22.3455 41.0036 22.2442C41.0773 22.1705 41.0896 22.0553 41.0328 21.9678C40.6515 21.3791 40.4161 20.7244 40.3277 20.0558C40.1579 18.7738 38.961 17.8852 37.6937 18.1397C37.6772 18.1428 37.6612 18.1461 37.6447 18.1498C36.6181 18.3696 35.6686 18.8593 34.9023 19.6255C33.1055 21.4224 32.8312 24.2268 33.9853 26.6652C34.3236 27.3802 35.1893 27.6696 35.8879 27.2987C36.2482 27.1074 36.3744 26.6572 36.1732 26.3022C35.2995 24.7604 35.3766 22.9408 36.4946 21.8229Z",
    fill: "url(#paint74_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4946 21.8229C36.9456 21.3719 37.5107 21.0902 38.1258 20.972C39.0951 20.7856 40.0868 21.2442 40.5966 22.1031C40.6165 22.1368 40.637 22.1702 40.658 22.2035C40.7344 22.3247 40.9024 22.3455 41.0036 22.2442C41.0773 22.1705 41.0896 22.0553 41.0328 21.9678C40.6515 21.3791 40.4161 20.7244 40.3277 20.0558C40.1579 18.7738 38.961 17.8852 37.6937 18.1397C37.6772 18.1428 37.6612 18.1461 37.6447 18.1498C36.6181 18.3696 35.6686 18.8593 34.9023 19.6255C33.1055 21.4224 32.8312 24.2268 33.9853 26.6652C34.3236 27.3802 35.1893 27.6696 35.8879 27.2987C36.2482 27.1074 36.3744 26.6572 36.1732 26.3022C35.2995 24.7604 35.3766 22.9408 36.4946 21.8229Z",
    fill: "url(#paint75_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4946 21.8229C36.9456 21.3719 37.5107 21.0902 38.1258 20.972C39.0951 20.7856 40.0868 21.2442 40.5966 22.1031C40.6165 22.1368 40.637 22.1702 40.658 22.2035C40.7344 22.3247 40.9024 22.3455 41.0036 22.2442C41.0773 22.1705 41.0896 22.0553 41.0328 21.9678C40.6515 21.3791 40.4161 20.7244 40.3277 20.0558C40.1579 18.7738 38.961 17.8852 37.6937 18.1397C37.6772 18.1428 37.6612 18.1461 37.6447 18.1498C36.6181 18.3696 35.6686 18.8593 34.9023 19.6255C33.1055 21.4224 32.8312 24.2268 33.9853 26.6652C34.3236 27.3802 35.1893 27.6696 35.8879 27.2987C36.2482 27.1074 36.3744 26.6572 36.1732 26.3022C35.2995 24.7604 35.3766 22.9408 36.4946 21.8229Z",
    fill: "url(#paint76_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2421 26.7471C46.2454 26.7311 46.2492 26.7146 46.2521 26.6981C46.5066 25.4308 45.618 24.2339 44.3361 24.0641C43.6674 23.9758 43.0128 23.7403 42.4241 23.359C42.3366 23.3022 42.2214 23.3144 42.1476 23.3882C42.0464 23.4894 42.0672 23.6575 42.1883 23.7338C42.2216 23.7548 42.2551 23.7753 42.2887 23.7952C43.1476 24.305 43.6062 25.2967 43.4199 26.266C43.3016 26.881 43.02 27.4462 42.569 27.8972C41.451 29.0151 39.6315 29.0922 38.0895 28.2183C37.7346 28.0171 37.2843 28.1434 37.093 28.5036C36.7221 29.2022 37.0116 30.068 37.7265 30.4062C40.1651 31.5603 42.9695 31.286 44.7664 29.4892C45.5326 28.7232 46.0222 27.7737 46.2421 26.7471Z",
    fill: "url(#paint77_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2421 26.7471C46.2454 26.7311 46.2492 26.7146 46.2521 26.6981C46.5066 25.4308 45.618 24.2339 44.3361 24.0641C43.6674 23.9758 43.0128 23.7403 42.4241 23.359C42.3366 23.3022 42.2214 23.3144 42.1476 23.3882C42.0464 23.4894 42.0672 23.6575 42.1883 23.7338C42.2216 23.7548 42.2551 23.7753 42.2887 23.7952C43.1476 24.305 43.6062 25.2967 43.4199 26.266C43.3016 26.881 43.02 27.4462 42.569 27.8972C41.451 29.0151 39.6315 29.0922 38.0895 28.2183C37.7346 28.0171 37.2843 28.1434 37.093 28.5036C36.7221 29.2022 37.0116 30.068 37.7265 30.4062C40.1651 31.5603 42.9695 31.286 44.7664 29.4892C45.5326 28.7232 46.0222 27.7737 46.2421 26.7471Z",
    fill: "url(#paint78_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2421 26.7471C46.2454 26.7311 46.2492 26.7146 46.2521 26.6981C46.5066 25.4308 45.618 24.2339 44.3361 24.0641C43.6674 23.9758 43.0128 23.7403 42.4241 23.359C42.3366 23.3022 42.2214 23.3144 42.1476 23.3882C42.0464 23.4894 42.0672 23.6575 42.1883 23.7338C42.2216 23.7548 42.2551 23.7753 42.2887 23.7952C43.1476 24.305 43.6062 25.2967 43.4199 26.266C43.3016 26.881 43.02 27.4462 42.569 27.8972C41.451 29.0151 39.6315 29.0922 38.0895 28.2183C37.7346 28.0171 37.2843 28.1434 37.093 28.5036C36.7221 29.2022 37.0116 30.068 37.7265 30.4062C40.1651 31.5603 42.9695 31.286 44.7664 29.4892C45.5326 28.7232 46.0222 27.7737 46.2421 26.7471Z",
    fill: "url(#paint79_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9504 20.3804C39.0368 20.397 39.239 20.2369 39.2969 19.9359C39.3548 19.635 39.2266 19.4112 39.1402 19.3946C39.0537 19.378 38.8515 19.5381 38.7936 19.8391C38.7357 20.14 38.864 20.3638 38.9504 20.3804Z",
    fill: "url(#paint80_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5938 20.3419C37.6796 20.3227 37.8012 20.0952 37.7344 19.7962C37.6676 19.4971 37.4608 19.3431 37.3748 19.3622C37.289 19.3813 37.1673 19.6089 37.2341 19.9079C37.3011 20.207 37.5079 20.3611 37.5938 20.3419Z",
    fill: "url(#paint81_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3063 21.2417C36.3727 21.184 36.3713 20.9261 36.1701 20.6948C35.9689 20.4636 35.7138 20.4266 35.6474 20.4844C35.581 20.5422 35.5823 20.8001 35.7835 21.0312C35.9846 21.2625 36.2398 21.2995 36.3063 21.2417Z",
    fill: "url(#paint82_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.43 22.5636C35.4545 22.4791 35.3136 22.2631 35.0193 22.1777C34.7249 22.0925 34.4904 22.1996 34.4659 22.2842C34.4414 22.3686 34.5823 22.5848 34.8766 22.67C35.1709 22.7554 35.4055 22.648 35.43 22.5636Z",
    fill: "url(#paint83_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0763 24.1779C35.0821 24.0901 34.8983 23.9092 34.5926 23.8887C34.2868 23.8682 34.0805 24.0229 34.0746 24.1107C34.0687 24.1985 34.2524 24.3796 34.5583 24.4C34.8641 24.4205 35.0704 24.2657 35.0763 24.1779Z",
    fill: "url(#paint84_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3753 25.6348C35.3412 25.5536 35.0958 25.4743 34.8133 25.5931C34.5308 25.7118 34.4158 25.9427 34.4499 26.0238C34.484 26.105 34.7294 26.1844 35.0119 26.0655C35.2944 25.9468 35.4094 25.7159 35.3753 25.6348Z",
    fill: "url(#paint85_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0112 25.4414C43.9946 25.355 44.1546 25.1528 44.4556 25.0949C44.7566 25.037 44.9803 25.1652 44.9969 25.2517C45.0135 25.3381 44.8535 25.5403 44.5525 25.5982C44.2516 25.6562 44.0279 25.5278 44.0112 25.4414Z",
    fill: "url(#paint86_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0497 26.7978C44.0688 26.712 44.2964 26.5904 44.5954 26.6572C44.8945 26.724 45.0485 26.9309 45.0294 27.0168C45.0102 27.1026 44.7827 27.2243 44.4837 27.1575C44.1846 27.0906 44.0305 26.8838 44.0497 26.7978Z",
    fill: "url(#paint87_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1499 28.0856C43.2076 28.0191 43.4655 28.0205 43.6967 28.2217C43.928 28.4229 43.965 28.678 43.9072 28.7444C43.8495 28.8108 43.5915 28.8095 43.3603 28.6083C43.1291 28.4071 43.0921 28.1519 43.1499 28.0856Z",
    fill: "url(#paint88_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8279 28.9616C41.9124 28.9371 42.1284 29.078 42.2138 29.3724C42.2991 29.6667 42.1919 29.9013 42.1073 29.9258C42.0228 29.9503 41.8067 29.8094 41.7215 29.515C41.6361 29.2207 41.7434 28.9861 41.8279 28.9616Z",
    fill: "url(#paint89_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2137 29.3153C40.3015 29.3095 40.4824 29.4933 40.5029 29.799C40.5234 30.1048 40.3686 30.3111 40.2809 30.317C40.1931 30.3229 40.012 30.1392 39.9916 29.8333C39.9711 29.5275 40.1259 29.3213 40.2137 29.3153Z",
    fill: "url(#paint90_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7568 29.0165C38.838 29.0506 38.9173 29.296 38.7985 29.5785C38.6798 29.861 38.4489 29.976 38.3678 29.9419C38.2866 29.9078 38.2072 29.6624 38.3261 29.3799C38.4448 29.0974 38.6757 28.9824 38.7568 29.0165Z",
    fill: "url(#paint91_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.064 29.7349C31.742 29.2749 32.5518 28.9287 33.4436 28.7335C32.3705 28.7939 31.3761 29.0365 30.5333 29.427C30.0523 29.6497 29.4464 29.7217 28.8436 29.6382L28.7768 29.6289C26.4996 29.3133 25.711 27.2027 27.582 26.4163C28.5253 26.0197 29.6399 25.8012 30.8331 25.8052C29.2648 25.1281 27.7 24.281 27.2382 23.9501C26.2854 23.2672 26.0667 21.9411 26.7497 20.9883C27.4327 20.0355 28.7587 19.8167 29.7115 20.4997C30.1731 20.8307 31.478 22.0405 32.6229 23.3082C32.2359 22.1795 32.0849 21.0537 32.1575 20.0331C32.3014 18.0087 34.5534 18.0775 35.5837 20.1328L35.6138 20.1931C35.8866 20.7371 36.013 21.334 35.9565 21.861C35.8575 22.7847 35.9471 23.8042 36.2346 24.8398C36.1331 23.9326 36.2008 23.0545 36.4186 22.2648C36.9166 20.4591 39.0985 20.7511 39.7392 22.7044L39.758 22.7617C39.9275 23.2787 39.9453 23.8284 39.7971 24.2966C39.3909 25.5801 39.3905 27.1215 39.8921 28.6507C39.8937 28.6557 39.8953 28.6607 39.8969 28.6655C40.1667 29.4826 40.7027 30.1857 41.402 30.6869L44.0819 32.6078C44.3728 32.8163 44.4658 33.2223 44.2661 33.5192C44.0594 33.8266 43.6414 33.9004 43.3425 33.6862L40.6404 31.7493C39.9411 31.2481 39.1031 30.9662 38.2427 30.9732C38.2376 30.9732 38.2323 30.9733 38.2271 30.9733C36.6178 30.9896 35.1582 31.4849 34.0732 32.2819C33.6775 32.5727 33.1512 32.7323 32.6071 32.7379L32.5467 32.7385C30.4913 32.759 29.5139 30.7864 31.064 29.7349Z",
    fill: "url(#paint92_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3428 33.686L40.6407 31.7491C39.9414 31.2479 39.1034 30.966 38.243 30.973C38.2378 30.973 38.2326 30.9731 38.2273 30.9731C36.618 30.9894 35.1584 31.4847 34.0734 32.2817C33.6777 32.5725 33.1514 32.7321 32.6073 32.7377L32.5469 32.7383C30.4913 32.759 29.5139 30.7864 31.064 29.7349C31.742 29.2749 32.5518 28.9287 33.4436 28.7335C32.3705 28.7938 31.3761 29.0365 30.5333 29.427C30.0523 29.6497 29.4464 29.7217 28.8436 29.6382L28.7768 29.6289C26.4996 29.3133 25.711 27.2027 27.582 26.4163C28.5253 26.0197 29.6399 25.8012 30.8331 25.8052C29.2648 25.1281 27.7 24.281 27.2382 23.9501C26.2854 23.2672 26.0667 21.9411 26.7497 20.9883L44.2543 33.5352C44.0439 33.8284 43.6362 33.8963 43.3428 33.686Z",
    fill: "url(#paint93_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6074 32.7377L32.547 32.7383C30.4913 32.759 29.514 30.7864 31.0641 29.7349C31.742 29.2749 32.5519 28.9287 33.4437 28.7335C32.3705 28.7939 31.3762 29.0365 30.5333 29.427C30.0524 29.6497 29.4465 29.7217 28.8437 29.6382L28.7769 29.6289C27.1346 29.4013 26.267 28.2402 26.6124 27.3154C27.5289 27.0278 28.3841 26.8171 29.1748 26.6662C31.9588 26.135 34.8383 26.7859 37.1418 28.4372L44.2541 33.5353C44.0438 33.8285 43.6361 33.8964 43.3427 33.6861L40.5975 31.7185C39.9115 31.2267 39.0869 30.9657 38.2428 30.9732L38.2271 30.9733C36.6178 30.9895 35.1581 31.4848 34.0732 32.2818C33.6777 32.5725 33.1514 32.7322 32.6074 32.7377Z",
    fill: "url(#paint94_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6175 30.9283L44.2543 33.5352C44.044 33.8284 43.6363 33.8963 43.3429 33.686L40.5977 31.7184C39.9117 31.2266 39.0871 30.9656 38.243 30.9731L38.2273 30.9732C36.618 30.9894 35.1584 31.4847 34.0734 32.2817C33.6777 32.5725 33.1514 32.7321 32.6073 32.7377L32.5469 32.7383C31.3785 32.75 30.5593 32.1177 30.3538 31.3767C31.9318 30.1606 33.697 29.6527 35.2681 29.487C37.1652 29.2871 39.0673 29.8172 40.6175 30.9283Z",
    fill: "url(#paint95_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6587 27.7719C39.7187 28.064 39.796 28.3574 39.8921 28.6505C39.8938 28.6555 39.8954 28.6605 39.897 28.6653C40.1667 29.4824 40.7028 30.1855 41.4021 30.6867L44.082 32.6076C44.3729 32.8161 44.4659 33.2221 44.2662 33.519C44.0595 33.8264 43.6415 33.9002 43.3426 33.686L40.6405 31.7491C39.9412 31.2479 39.1032 30.966 38.2428 30.9731C38.2375 30.9731 38.2324 30.9732 38.2271 30.9732C37.9187 30.9763 37.616 30.9973 37.3201 31.0343L39.6587 27.7719Z",
    fill: "url(#paint96_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7581 22.7615L39.7394 22.7042C39.0987 20.7509 36.9167 20.4588 36.4188 22.2646C36.201 23.0543 36.1331 23.9324 36.2348 24.8397C35.9473 23.804 35.8576 22.7845 35.9566 21.8608C36.0132 21.3338 35.8867 20.7369 35.614 20.1929L35.5838 20.1326C34.8407 18.6504 33.4626 18.2018 32.6978 18.8259C32.7197 19.7861 32.7948 20.6638 32.906 21.461C33.2971 24.2682 34.8384 26.7859 37.142 28.4371L44.2543 33.5352C44.4645 33.2418 44.3978 32.8338 44.1044 32.6235L41.3592 30.6559C40.6731 30.1641 40.1611 29.4671 39.8971 28.6653L39.8922 28.6505C39.3906 27.1213 39.3909 25.5799 39.7973 24.2964C39.9454 23.8282 39.9277 23.2785 39.7581 22.7615Z",
    fill: "url(#paint97_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6174 30.9283L44.2542 33.5352C44.4644 33.2418 44.3977 32.8338 44.1043 32.6235L41.3591 30.6559C40.6731 30.1641 40.1611 29.4671 39.897 28.6653L39.8921 28.6505C39.3906 27.1213 39.3908 25.5799 39.7972 24.2964C39.9453 23.8282 39.9277 23.2786 39.758 22.7615L39.7393 22.7042C39.3751 21.594 38.5132 21.0212 37.7453 21.0646C37.1005 22.9495 37.1865 24.7844 37.5343 26.3255C37.9542 28.186 39.0672 29.8172 40.6174 30.9283Z",
    fill: "url(#paint98_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7671 28.5808C37.9405 29.0969 38.4996 29.3746 39.0156 29.2011C40.7385 28.6219 42.5723 28.3486 44.3931 28.3937C45.1033 28.4112 45.6121 27.7124 45.3858 27.0391C45.2481 26.6295 44.8689 26.349 44.437 26.3386C42.3795 26.2889 40.3076 26.5983 38.3607 27.2527C37.8446 27.4262 37.5669 27.9853 37.7404 28.5013L37.7671 28.5808Z",
    fill: "url(#paint99_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4989 28.4622L41.8286 26.4681C40.6489 26.6133 39.484 26.8752 38.3607 27.2528C37.8446 27.4263 37.5669 27.9854 37.7404 28.5014L37.7671 28.5809C37.9405 29.097 38.4996 29.3747 39.0156 29.2012C40.141 28.8229 41.3136 28.576 42.4989 28.4622Z",
    fill: "url(#paint100_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6145 24.8244C26.7401 24.8244 25.2207 26.3439 25.2207 28.2182C25.2207 30.0925 26.7401 31.6119 28.6145 31.6119C30.4888 31.6119 32.0082 30.0925 32.0082 28.2182C32.0082 26.3439 30.4888 24.8244 28.6145 24.8244ZM28.6145 29.5235C27.8936 29.5235 27.3092 28.9392 27.3092 28.2183C27.3092 27.4974 27.8936 26.913 28.6145 26.913C29.3354 26.913 29.9197 27.4974 29.9197 28.2183C29.9197 28.9392 29.3354 29.5235 28.6145 29.5235Z",
    fill: "url(#paint101_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2207 28.2182C25.2207 30.0925 26.7401 31.6119 28.6146 31.6119C30.489 31.6119 32.0084 30.0925 32.0084 28.2182C32.0084 27.5891 31.8365 27.0003 31.5382 26.4951H25.6909C25.3926 27.0004 25.2207 27.5891 25.2207 28.2182ZM28.6146 26.9129C29.3355 26.9129 29.9198 27.4973 29.9198 28.2182C29.9198 28.9391 29.3355 29.5234 28.6146 29.5234C27.8937 29.5234 27.3093 28.9391 27.3093 28.2182C27.3093 27.4973 27.8937 26.9129 28.6146 26.9129Z",
    fill: "url(#paint102_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2148 30.618C27.5402 31.9434 29.689 31.9434 31.0143 30.618C32.3397 29.2926 32.3397 27.1438 31.0143 25.8185C30.5695 25.3736 30.0317 25.0788 29.4635 24.9326L25.3289 29.0673C25.4751 29.6354 25.77 30.1731 26.2148 30.618ZM27.6916 27.2952C28.2013 26.7854 29.0278 26.7854 29.5375 27.2952C30.0473 27.805 30.0473 28.6314 29.5375 29.1412C29.0278 29.651 28.2013 29.651 27.6916 29.1412C27.1818 28.6314 27.1818 27.805 27.6916 27.2952Z",
    fill: "url(#paint103_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9623 25.5237C15.9124 26.3415 15.692 27.1941 15.3018 28.0195C15.9094 27.1329 16.3246 26.1975 16.5302 25.2916C16.6476 24.7747 16.9606 24.251 17.395 23.8247L17.4431 23.7774C19.0839 22.167 21.2367 22.8316 20.7168 24.7935C20.4547 25.7825 19.947 26.7986 19.2151 27.741C20.7091 26.9127 22.3355 26.191 22.8796 26.0276C24.0023 25.6903 25.1859 26.327 25.5232 27.4497C25.8605 28.5724 25.2239 29.7561 24.1011 30.0934C23.5572 30.2568 21.8022 30.5512 20.0992 30.6834C21.2293 31.0663 22.213 31.6343 22.9767 32.3151C24.4919 33.6655 23.0619 35.4066 20.8052 34.9672L20.739 34.9543C20.1417 34.838 19.5919 34.5735 19.2091 34.2069C18.5382 33.5645 17.6761 33.0127 16.6805 32.6078C17.461 33.0815 18.1149 33.6715 18.6072 34.3263C19.7329 35.8234 18.169 37.3728 16.231 36.687L16.1742 36.6669C15.6612 36.4854 15.2152 36.1638 14.9349 35.7605C14.1668 34.6549 12.9464 33.7132 11.4293 33.1764C11.4244 33.1746 11.4194 33.1729 11.4145 33.1712C10.6028 32.8857 9.71872 32.8809 8.8947 33.1284L5.73698 34.0773C5.39421 34.1803 5.01599 34.006 4.9028 33.6664C4.78562 33.3151 4.98249 32.939 5.33464 32.8332L8.51862 31.8766C9.34265 31.629 10.0776 31.1376 10.5975 30.4521C10.6007 30.4479 10.6039 30.4438 10.607 30.4396C11.577 29.1554 12.0762 27.6971 12.1079 26.3512C12.1194 25.8603 12.3143 25.346 12.6423 24.9118L12.6786 24.8637C13.9175 23.2233 16.0763 23.6541 15.9623 25.5237Z",
    fill: "url(#paint104_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3342 32.8332L8.51818 31.8765C9.34221 31.629 10.0772 31.1376 10.5971 30.452C10.6002 30.4478 10.6034 30.4437 10.6066 30.4395C11.5766 29.1553 12.0758 27.697 12.1074 26.3511C12.119 25.8602 12.3139 25.346 12.6418 24.9118L12.6781 24.8636C13.9172 23.2233 16.0761 23.6542 15.962 25.5238C15.9121 26.3416 15.6917 27.1942 15.3016 28.0196C15.9092 27.133 16.3243 26.1975 16.53 25.2917C16.6474 24.7748 16.9604 24.251 17.3947 23.8248L17.4429 23.7775C19.0836 22.1671 21.2364 22.8317 20.7165 24.7935C20.4544 25.7826 19.9468 26.7987 19.2149 27.7411C20.7088 26.9128 22.3353 26.1911 22.8793 26.0277C24.0021 25.6904 25.1857 26.327 25.523 27.4498L4.89699 33.647C4.79318 33.3013 4.9885 32.9371 5.3342 32.8332Z",
    fill: "url(#paint105_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6418 24.9117L12.6781 24.8636C13.9172 23.2233 16.0761 23.6541 15.962 25.5237C15.9121 26.3415 15.6917 27.1942 15.3015 28.0195C15.9092 27.1329 16.3243 26.1975 16.53 25.2916C16.6473 24.7747 16.9603 24.251 17.3947 23.8247L17.4429 23.7775C18.6262 22.616 20.0753 22.6382 20.5967 23.4765C20.2646 24.3778 19.9093 25.1837 19.5458 25.902C18.2661 28.4309 15.992 30.3133 13.2776 31.1288L4.89696 33.6469C4.79325 33.3013 4.98846 32.9369 5.33416 32.833L8.56883 31.8611C9.37723 31.6183 10.0875 31.1247 10.5971 30.4519L10.6065 30.4394C11.5765 29.1552 12.0758 27.6969 12.1074 26.351C12.1189 25.8602 12.3139 25.3459 12.6418 24.9117Z",
    fill: "url(#paint106_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18255 32.3595L4.8972 33.6471C4.79349 33.3015 4.98871 32.9371 5.33441 32.8332L8.56908 31.8613C9.37747 31.6185 10.0877 31.1249 10.5973 30.4521L10.6068 30.4396C11.5768 29.1554 12.076 27.6971 12.1077 26.3512C12.1192 25.8603 12.3141 25.346 12.642 24.9118L12.6784 24.8637C13.3827 23.9314 14.3837 23.6689 15.096 23.9587C15.0952 25.9509 14.4192 27.6589 13.5909 29.0041C12.5907 30.6282 11.0092 31.8106 9.18255 32.3595Z",
    fill: "url(#paint107_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2674 33.5282C11.9995 33.3973 11.7199 33.2793 11.4291 33.1764C11.4242 33.1746 11.4193 33.1729 11.4144 33.1712C10.6027 32.8857 9.71858 32.8809 8.89455 33.1284L5.73674 34.0773C5.39397 34.1803 5.01574 34.006 4.90256 33.6664C4.78537 33.3151 4.98225 32.939 5.3344 32.8332L8.51838 31.8766C9.3424 31.629 10.0774 31.1376 10.5973 30.4521C10.6004 30.4479 10.6036 30.4438 10.6068 30.4396C10.7927 30.1935 10.961 29.9409 11.1122 29.684L12.2674 33.5282Z",
    fill: "url(#paint108_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.174 36.667L16.2309 36.6871C18.1688 37.3729 19.7327 35.8235 18.607 34.3264C18.1146 33.6716 17.4607 33.0816 16.6804 32.6079C17.676 33.0128 18.5381 33.5646 19.2089 34.207C19.5917 34.5736 20.1416 34.8381 20.7389 34.9544L20.8051 34.9673C22.4325 35.2842 23.6295 34.4669 23.6024 33.4801C22.8286 32.9111 22.0879 32.4345 21.3887 32.0355C18.9271 30.6307 15.992 30.3134 13.2776 31.129L4.89697 33.6471C5.00088 33.9927 5.36465 34.1891 5.71035 34.0852L8.94502 33.1133C9.75342 32.8704 10.6181 32.8907 11.4142 33.1713L11.4289 33.1765C12.9461 33.7133 14.1664 34.655 14.9346 35.7606C15.2149 36.1638 15.661 36.4855 16.174 36.667Z",
    fill: "url(#paint109_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18257 32.3595L4.89722 33.6471C5.00112 33.9927 5.36489 34.1891 5.7106 34.0852L8.94526 33.1133C9.75366 32.8704 10.6183 32.8907 11.4144 33.1713L11.4292 33.1765C12.9463 33.7133 14.1666 34.655 14.9348 35.7606C15.215 36.1638 15.6611 36.4855 16.1741 36.667L16.2309 36.6871C17.3325 37.0769 18.3124 36.7442 18.747 36.1097C17.6483 34.4479 16.1428 33.3953 14.7102 32.7294C12.9805 31.9255 11.0092 31.8106 9.18257 32.3595Z",
    fill: "url(#paint110_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4808 47.9115H21.5188C17.5206 47.9115 13.9885 45.3071 12.8068 41.4874L12.6053 40.8362C12.3863 40.1281 12.9156 39.4104 13.6567 39.4104H36.3429C37.0841 39.4104 37.6134 40.1281 37.3943 40.8362L37.1928 41.4874C36.0112 45.307 32.4792 47.9115 28.4808 47.9115Z",
    fill: "url(#paint111_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8564 41.6426C14.0849 45.3774 17.5749 47.9115 21.5188 47.9115H28.4808C32.4246 47.9115 35.9146 45.3773 37.1431 41.6426H12.8564Z",
    fill: "url(#paint112_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3431 39.4104H23.0056V47.9115H28.481C32.4792 47.9115 36.0113 45.3071 37.193 41.4874L37.3945 40.8362C37.6135 40.1281 37.0842 39.4104 36.3431 39.4104Z",
    fill: "url(#paint113_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9931 45.1717H18.0069C9.9747 45.1717 2.87909 39.9396 0.505064 32.2661L0.100279 30.9579C-0.33976 29.5355 0.723522 28.0935 2.21249 28.0935H47.7876C49.2766 28.0935 50.3398 29.5355 49.8998 30.9579L49.495 32.2661C47.1209 39.9396 40.0253 45.1717 31.9931 45.1717Z",
    fill: "url(#paint114_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.60498 32.5777C3.07275 40.0808 10.084 45.1717 18.0069 45.1717H31.9931C39.9161 45.1717 46.9272 40.0808 49.395 32.5777H0.60498Z",
    fill: "url(#paint115_linear_154_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7874 28.0935H20.9934V45.1717H31.993C40.0252 45.1717 47.1208 39.9396 49.4949 32.2661L49.8997 30.9579C50.3397 29.5355 49.2764 28.0935 47.7874 28.0935Z",
    fill: "url(#paint116_linear_154_1950)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_154_1950",
    x1: 31.312,
    y1: 12.411,
    x2: 35.3497,
    y2: 14.0818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4573A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_154_1950",
    x1: 32.0322,
    y1: 15.5213,
    x2: 30.2222,
    y2: 20.3944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8794,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_154_1950",
    x1: 10.6386,
    y1: 18.8861,
    x2: 4.16195,
    y2: 25.2193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78A91F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1553,
    stopColor: "#6DA423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    stopColor: "#50992E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7835,
    stopColor: "#218741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#017B4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_154_1950",
    x1: 12.1001,
    y1: 19.8876,
    x2: 6.55144,
    y2: 23.2186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017B4E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#01774B",
    stopOpacity: 0.473
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8807,
    stopColor: "#016D44",
    stopOpacity: 0.881
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026841"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_154_1950",
    x1: 5.27497,
    y1: 23.7012,
    x2: 10.8381,
    y2: 19.4584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017B4E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#01774B",
    stopOpacity: 0.473
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8807,
    stopColor: "#016D44",
    stopOpacity: 0.881
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026841"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_154_1950",
    x1: 7.36486,
    y1: 24.1186,
    x2: 9.69235,
    y2: 20.5019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017B4E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#01774B",
    stopOpacity: 0.473
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8807,
    stopColor: "#016D44",
    stopOpacity: 0.881
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026841"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_154_1950",
    x1: 8.87332,
    y1: 25.4945,
    x2: 10.8139,
    y2: 22.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017B4E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#01774B",
    stopOpacity: 0.473
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8807,
    stopColor: "#016D44",
    stopOpacity: 0.881
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026841"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_154_1950",
    x1: 13.5808,
    y1: 21.6701,
    x2: 8.66226,
    y2: 23.6016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017B4E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#01774B",
    stopOpacity: 0.473
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8807,
    stopColor: "#016D44",
    stopOpacity: 0.881
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026841"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_154_1950",
    x1: 11.2451,
    y1: 17.7432,
    x2: 28.5943,
    y2: 20.1387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A274BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1435,
    stopColor: "#976FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3928,
    stopColor: "#7B61B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7158,
    stopColor: "#4D4BA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F3596"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_154_1950",
    x1: 22.5341,
    y1: 19.2668,
    x2: 17.9584,
    y2: 18.7069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F3596",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2618,
    stopColor: "#1E3190",
    stopOpacity: 0.262
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6062,
    stopColor: "#1D267F",
    stopOpacity: 0.606
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9953,
    stopColor: "#1B1464",
    stopOpacity: 0.995
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1464"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_154_1950",
    x1: 21.3324,
    y1: 22.5751,
    x2: 19.265,
    y2: 19.5374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F3596",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2618,
    stopColor: "#1E3190",
    stopOpacity: 0.262
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6062,
    stopColor: "#1D267F",
    stopOpacity: 0.606
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9953,
    stopColor: "#1B1464",
    stopOpacity: 0.995
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1464"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_154_1950",
    x1: 22.6268,
    y1: 27.863,
    x2: 18.6083,
    y2: 23.1936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F3596",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2618,
    stopColor: "#1E3190",
    stopOpacity: 0.262
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6062,
    stopColor: "#1D267F",
    stopOpacity: 0.606
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9953,
    stopColor: "#1B1464",
    stopOpacity: 0.995
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1464"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_154_1950",
    x1: 20.4717,
    y1: 25.0548,
    x2: 21.1587,
    y2: 26.6613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F3596",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2618,
    stopColor: "#1E3190",
    stopOpacity: 0.262
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6062,
    stopColor: "#1D267F",
    stopOpacity: 0.606
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9953,
    stopColor: "#1B1464",
    stopOpacity: 0.995
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1464"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_154_1950",
    x1: 14.6909,
    y1: 19.9161,
    x2: 18.2841,
    y2: 19.1475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F3596",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2618,
    stopColor: "#1E3190",
    stopOpacity: 0.262
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6062,
    stopColor: "#1D267F",
    stopOpacity: 0.606
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9953,
    stopColor: "#1B1464",
    stopOpacity: 0.995
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1464"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_154_1950",
    x1: 11.6555,
    y1: 22.6924,
    x2: 15.778,
    y2: 22.2636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F3596",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2618,
    stopColor: "#1E3190",
    stopOpacity: 0.262
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6062,
    stopColor: "#1D267F",
    stopOpacity: 0.606
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9953,
    stopColor: "#1B1464",
    stopOpacity: 0.995
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1464"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_154_1950",
    x1: 19.4268,
    y1: 23.2539,
    x2: 19.6898,
    y2: 24.0815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1759,
    stopColor: "#FF9AA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4315,
    stopColor: "#FF8699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    stopColor: "#FF6780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_154_1950",
    x1: 20.5728,
    y1: 23.4135,
    x2: 17.3844,
    y2: 24.6558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2613,
    stopColor: "#F64452",
    stopOpacity: 0.261
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6438,
    stopColor: "#E33A4B",
    stopOpacity: 0.644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA2E43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_154_1950",
    x1: 21.6274,
    y1: 17.7642,
    x2: 21.8904,
    y2: 18.5919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1759,
    stopColor: "#FF9AA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4315,
    stopColor: "#FF8699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    stopColor: "#FF6780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_154_1950",
    x1: 22.1082,
    y1: 18.3642,
    x2: 19.6084,
    y2: 19.0897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2613,
    stopColor: "#F64452",
    stopOpacity: 0.261
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6438,
    stopColor: "#E33A4B",
    stopOpacity: 0.644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA2E43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_154_1950",
    x1: 15.5999,
    y1: 21.7231,
    x2: 14.8381,
    y2: 22.1399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1759,
    stopColor: "#FF9AA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4315,
    stopColor: "#FF8699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    stopColor: "#FF6780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_154_1950",
    x1: 17.8006,
    y1: 16.2335,
    x2: 17.0388,
    y2: 16.6503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1759,
    stopColor: "#FF9AA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4315,
    stopColor: "#FF8699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    stopColor: "#FF6780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_154_1950",
    x1: 16.4069,
    y1: 23.9282,
    x2: 17.7996,
    y2: 24.4864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1759,
    stopColor: "#FF9AA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4315,
    stopColor: "#FF8699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    stopColor: "#FF6780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_154_1950",
    x1: 15.7354,
    y1: 26.9079,
    x2: 14.3053,
    y2: 30.4754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2613,
    stopColor: "#F64452",
    stopOpacity: 0.261
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6438,
    stopColor: "#E33A4B",
    stopOpacity: 0.644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA2E43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_154_1950",
    x1: 48.5706,
    y1: 20.1162,
    x2: 34.3917,
    y2: 20.2473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A274BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1435,
    stopColor: "#976FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3928,
    stopColor: "#7B61B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7158,
    stopColor: "#4D4BA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F3596"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_154_1950",
    x1: 39.3093,
    y1: 20.1824,
    x2: 43.0437,
    y2: 20.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F3596",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2618,
    stopColor: "#1E3190",
    stopOpacity: 0.262
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6062,
    stopColor: "#1D267F",
    stopOpacity: 0.606
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9953,
    stopColor: "#1B1464",
    stopOpacity: 0.995
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1464"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_154_1950",
    x1: 39.9339,
    y1: 22.9645,
    x2: 41.9081,
    y2: 20.7367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F3596",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2618,
    stopColor: "#1E3190",
    stopOpacity: 0.262
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6062,
    stopColor: "#1D267F",
    stopOpacity: 0.606
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9953,
    stopColor: "#1B1464",
    stopOpacity: 0.995
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1464"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_154_1950",
    x1: 38.3489,
    y1: 27.0802,
    x2: 42.0592,
    y2: 23.7423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F3596",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2618,
    stopColor: "#1E3190",
    stopOpacity: 0.262
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6062,
    stopColor: "#1D267F",
    stopOpacity: 0.606
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9953,
    stopColor: "#1B1464",
    stopOpacity: 0.995
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1464"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_154_1950",
    x1: 40.37,
    y1: 25.0458,
    x2: 39.6524,
    y2: 26.2658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F3596",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2618,
    stopColor: "#1E3190",
    stopOpacity: 0.262
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6062,
    stopColor: "#1D267F",
    stopOpacity: 0.606
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9953,
    stopColor: "#1B1464",
    stopOpacity: 0.995
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1464"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_154_1950",
    x1: 45.5554,
    y1: 21.5111,
    x2: 42.7474,
    y2: 20.5233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F3596",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2618,
    stopColor: "#1E3190",
    stopOpacity: 0.262
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6062,
    stopColor: "#1D267F",
    stopOpacity: 0.606
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9953,
    stopColor: "#1B1464",
    stopOpacity: 0.995
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1464"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_154_1950",
    x1: 47.6975,
    y1: 24.056,
    x2: 44.4292,
    y2: 23.2866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F3596",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2618,
    stopColor: "#1E3190",
    stopOpacity: 0.262
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6062,
    stopColor: "#1D267F",
    stopOpacity: 0.606
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9953,
    stopColor: "#1B1464",
    stopOpacity: 0.995
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1464"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_154_1950",
    x1: 41.3953,
    y1: 23.7064,
    x2: 41.0988,
    y2: 24.3444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1759,
    stopColor: "#FF9AA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4315,
    stopColor: "#FF8699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    stopColor: "#FF6780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_154_1950",
    x1: 40.4581,
    y1: 23.7166,
    x2: 42.892,
    y2: 25.0433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2613,
    stopColor: "#F64452",
    stopOpacity: 0.261
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6438,
    stopColor: "#E33A4B",
    stopOpacity: 0.644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA2E43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_154_1950",
    x1: 40.1927,
    y1: 19.0686,
    x2: 39.8961,
    y2: 19.7065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1759,
    stopColor: "#FF9AA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4315,
    stopColor: "#FF8699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    stopColor: "#FF6780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_154_1950",
    x1: 39.7446,
    y1: 19.5011,
    x2: 41.6784,
    y2: 20.3416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2613,
    stopColor: "#F64452",
    stopOpacity: 0.261
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6438,
    stopColor: "#E33A4B",
    stopOpacity: 0.644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA2E43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_154_1950",
    x1: 44.6383,
    y1: 22.8695,
    x2: 45.2075,
    y2: 23.2829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1759,
    stopColor: "#FF9AA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4315,
    stopColor: "#FF8699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    stopColor: "#FF6780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_154_1950",
    x1: 43.4357,
    y1: 18.2317,
    x2: 44.0049,
    y2: 18.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1759,
    stopColor: "#FF9AA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4315,
    stopColor: "#FF8699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    stopColor: "#FF6780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_154_1950",
    x1: 43.7523,
    y1: 24.5594,
    x2: 42.5758,
    y2: 24.8645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1759,
    stopColor: "#FF9AA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4315,
    stopColor: "#FF8699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    stopColor: "#FF6780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_154_1950",
    x1: 43.9849,
    y1: 27.0229,
    x2: 44.7664,
    y2: 30.0368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2613,
    stopColor: "#F64452",
    stopOpacity: 0.261
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6438,
    stopColor: "#E33A4B",
    stopOpacity: 0.644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA2E43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_154_1950",
    x1: 2.5251,
    y1: 24.4963,
    x2: 4.84883,
    y2: 28.3691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_154_1950",
    x1: 3.39385,
    y1: 26.7969,
    x2: 3.39385,
    y2: 29.1545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_154_1950",
    x1: 3.3814,
    y1: 25.9353,
    x2: 4.98257,
    y2: 27.0839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_154_1950",
    x1: 36.7297,
    y1: 14.3323,
    x2: 39.0533,
    y2: 18.2051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_154_1950",
    x1: 37.5984,
    y1: 16.6329,
    x2: 37.5984,
    y2: 18.9905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_154_1950",
    x1: 37.5861,
    y1: 15.7713,
    x2: 39.1873,
    y2: 16.9199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_154_1950",
    x1: 10.0551,
    y1: 19.3204,
    x2: 9.53703,
    y2: 20.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_154_1950",
    x1: 7.99481,
    y1: 19.7464,
    x2: 6.37916,
    y2: 20.0955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_154_1950",
    x1: 7.20957,
    y1: 21.8212,
    x2: 7.45195,
    y2: 31.9592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78A91F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1553,
    stopColor: "#6DA423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    stopColor: "#50992E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7835,
    stopColor: "#218741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#017B4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_154_1950",
    x1: 9.61211,
    y1: 23.9125,
    x2: 18.6091,
    y2: 37.2716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1F19E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78A91F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_154_1950",
    x1: 10.8065,
    y1: 30.2217,
    x2: 9.11016,
    y2: 36.1591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_154_1950",
    x1: 14.0967,
    y1: 29.1728,
    x2: 18.2974,
    y2: 32.9694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_154_1950",
    x1: 11.2684,
    y1: 19.3644,
    x2: 15.4489,
    y2: 29.7447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_154_1950",
    x1: 7.39121,
    y1: 26.5355,
    x2: 15.6106,
    y2: 35.4617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_154_1950",
    x1: 13.2166,
    y1: 26.3236,
    x2: 15.6602,
    y2: 33.5535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_154_1950",
    x1: 6.62373,
    y1: 19.9321,
    x2: 11.3494,
    y2: 30.2721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_154_1950",
    x1: 12.4769,
    y1: 21.6932,
    x2: 13.0949,
    y2: 25.5227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_154_1950",
    x1: 9.9511,
    y1: 27.7544,
    x2: 10.5691,
    y2: 31.5839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_154_1950",
    x1: 14.7963,
    y1: 27.4298,
    x2: 12.881,
    y2: 28.6144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_154_1950",
    x1: 13.8046,
    y1: 26.8483,
    x2: 14.1352,
    y2: 24.6221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_154_1950",
    x1: 9.44162,
    y1: 27.7511,
    x2: 7.52623,
    y2: 28.9357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_154_1950",
    x1: 9.81459,
    y1: 24.8297,
    x2: 7.32592,
    y2: 26.3689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_154_1950",
    x1: 9.53498,
    y1: 21.8393,
    x2: 9.70909,
    y2: 24.7572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_154_1950",
    x1: 13.1863,
    y1: 28.3194,
    x2: 13.3604,
    y2: 31.2373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_154_1950",
    x1: 20.984,
    y1: 23.3126,
    x2: 25.0793,
    y2: 31.3927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78A91F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1553,
    stopColor: "#6DA423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    stopColor: "#50992E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7835,
    stopColor: "#218741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#017B4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_154_1950",
    x1: 19.2779,
    y1: 23.791,
    x2: 23.4603,
    y2: 28.7297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017B4E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#01774B",
    stopOpacity: 0.473
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8807,
    stopColor: "#016D44",
    stopOpacity: 0.881
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026841"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_154_1950",
    x1: 24.514,
    y1: 29.5972,
    x2: 20.6112,
    y2: 23.7904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017B4E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#01774B",
    stopOpacity: 0.473
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8807,
    stopColor: "#016D44",
    stopOpacity: 0.881
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026841"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_154_1950",
    x1: 22.4008,
    y1: 29.3201,
    x2: 21.3603,
    y2: 25.1469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017B4E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#01774B",
    stopOpacity: 0.473
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8807,
    stopColor: "#016D44",
    stopOpacity: 0.881
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026841"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_154_1950",
    x1: 20.5299,
    y1: 30.1378,
    x2: 19.6622,
    y2: 26.6583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017B4E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#01774B",
    stopOpacity: 0.473
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8807,
    stopColor: "#016D44",
    stopOpacity: 0.881
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026841"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_154_1950",
    x1: 17.3026,
    y1: 25.0023,
    x2: 21.3386,
    y2: 28.4133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017B4E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#01774B",
    stopOpacity: 0.473
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8807,
    stopColor: "#016D44",
    stopOpacity: 0.881
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026841"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_154_1950",
    x1: 21.9614,
    y1: 25.6641,
    x2: 21.2158,
    y2: 27.2199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_154_1950",
    x1: 19.8603,
    y1: 25.7949,
    x2: 18.2104,
    y2: 25.9124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_154_1950",
    x1: 41.1661,
    y1: 19.4379,
    x2: 39.0363,
    y2: 28.8523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A72B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_154_1950",
    x1: 39.9167,
    y1: 51.854,
    x2: 39.9167,
    y2: -1.6844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1812,
    stopColor: "#FF9AA8",
    stopOpacity: 0.819
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4447,
    stopColor: "#FF8699",
    stopOpacity: 0.555
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7568,
    stopColor: "#FF6780",
    stopOpacity: 0.243
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4968",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_154_1950",
    x1: 36.8257,
    y1: 27.5581,
    x2: 33.5897,
    y2: 30.7941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72B2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#A22C2B",
    stopOpacity: 0.238
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5507,
    stopColor: "#912E29",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9042,
    stopColor: "#763227",
    stopOpacity: 0.904
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D3326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_154_1950",
    x1: 40.8263,
    y1: 28.8637,
    x2: 41.784,
    y2: 33.4922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72B2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#A22C2B",
    stopOpacity: 0.238
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5507,
    stopColor: "#912E29",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9042,
    stopColor: "#763227",
    stopOpacity: 0.904
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D3326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_154_1950",
    x1: 37.422,
    y1: 17.7058,
    x2: 36.9006,
    y2: 28.6554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A72B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_154_1950",
    x1: 36.3414,
    y1: 22.5985,
    x2: 33.6282,
    y2: 21.4812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72B2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#A22C2B",
    stopOpacity: 0.238
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5507,
    stopColor: "#912E29",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9042,
    stopColor: "#763227",
    stopOpacity: 0.904
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D3326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_154_1950",
    x1: 37.1693,
    y1: 22.7034,
    x2: 36.9565,
    y2: 17.9152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72B2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#A22C2B",
    stopOpacity: 0.238
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5507,
    stopColor: "#912E29",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9042,
    stopColor: "#763227",
    stopOpacity: 0.904
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D3326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_154_1950",
    x1: 41.8362,
    y1: 23.0063,
    x2: 41.4051,
    y2: 32.0585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A72B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_154_1950",
    x1: 43.0794,
    y1: 29.101,
    x2: 39.6746,
    y2: 25.4832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72B2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#A22C2B",
    stopOpacity: 0.238
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5507,
    stopColor: "#912E29",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9042,
    stopColor: "#763227",
    stopOpacity: 0.904
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D3326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_154_1950",
    x1: 41.9258,
    y1: 26.9027,
    x2: 43.043,
    y2: 23.6574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72B2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#A22C2B",
    stopOpacity: 0.238
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5507,
    stopColor: "#912E29",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9042,
    stopColor: "#763227",
    stopOpacity: 0.904
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D3326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_154_1950",
    x1: 39.4085,
    y1: 19.7876,
    x2: 38.8451,
    y2: 19.9456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_154_1950",
    x1: 37.7717,
    y1: 19.6044,
    x2: 37.3178,
    y2: 19.9738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_154_1950",
    x1: 36.2338,
    y1: 20.4941,
    x2: 36.0109,
    y2: 21.0347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_154_1950",
    x1: 34.8405,
    y1: 22.1955,
    x2: 34.9465,
    y2: 22.7713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_154_1950",
    x1: 34.3632,
    y1: 23.8091,
    x2: 34.5893,
    y2: 24.3491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_154_1950",
    x1: 34.6332,
    y1: 25.7129,
    x2: 35.0776,
    y2: 26.0939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_154_1950",
    x1: 44.6041,
    y1: 24.9836,
    x2: 44.4461,
    y2: 25.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_154_1950",
    x1: 44.7878,
    y1: 26.6201,
    x2: 44.4184,
    y2: 27.0739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_154_1950",
    x1: 43.8935,
    y1: 28.1541,
    x2: 43.3528,
    y2: 28.3771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_154_1950",
    x1: 42.1956,
    y1: 29.557,
    x2: 41.6198,
    y2: 29.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_154_1950",
    x1: 40.5846,
    y1: 30.0296,
    x2: 40.0447,
    y2: 29.8035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_154_1950",
    x1: 38.6784,
    y1: 29.7632,
    x2: 38.2973,
    y2: 29.3188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_154_1950",
    x1: 37.1377,
    y1: 22.6614,
    x2: 32.8386,
    y2: 34.4158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1F19E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78A91F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_154_1950",
    x1: 33.2005,
    y1: 29.943,
    x2: 37.125,
    y2: 25.3768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_154_1950",
    x1: 35.2054,
    y1: 30.9066,
    x2: 37.6722,
    y2: 25.3335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_154_1950",
    x1: 36.8121,
    y1: 34.2693,
    x2: 38.3512,
    y2: 28.3368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_154_1950",
    x1: 40.1757,
    y1: 30.6748,
    x2: 41.9183,
    y2: 31.9244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_154_1950",
    x1: 38.8675,
    y1: 25.8553,
    x2: 34.3803,
    y2: 29.9797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_154_1950",
    x1: 41.4616,
    y1: 27.0237,
    x2: 36.3364,
    y2: 30.3847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_154_1950",
    x1: 41.4627,
    y1: 27.0488,
    x2: 41.7115,
    y2: 28.7558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_154_1950",
    x1: 39.7923,
    y1: 28.329,
    x2: 38.4887,
    y2: 29.3464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_154_1950",
    x1: 27.7458,
    y1: 26.7704,
    x2: 30.0694,
    y2: 30.6432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_154_1950",
    x1: 28.6146,
    y1: 29.071,
    x2: 28.6146,
    y2: 31.4286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_154_1950",
    x1: 28.6022,
    y1: 28.2094,
    x2: 30.2034,
    y2: 29.3581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_154_1950",
    x1: 17.8314,
    y1: 34.6719,
    x2: 11.1465,
    y2: 24.0919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1F19E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78A91F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_154_1950",
    x1: 14.4678,
    y1: 27.1088,
    x2: 15.6885,
    y2: 33.0041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_154_1950",
    x1: 12.4807,
    y1: 28.1084,
    x2: 15.3887,
    y2: 33.4641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_154_1950",
    x1: 8.83705,
    y1: 27.3283,
    x2: 12.596,
    y2: 32.1686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_154_1950",
    x1: 9.63069,
    y1: 32.1864,
    x2: 7.57716,
    y2: 32.8038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_154_1950",
    x1: 14.2964,
    y1: 34.0644,
    x2: 13.769,
    y2: 27.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_154_1950",
    x1: 11.7875,
    y1: 35.4056,
    x2: 12.2543,
    y2: 29.2949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_154_1950",
    x1: 23.7399,
    y1: 39.0833,
    x2: 28.6858,
    y2: 46.5299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFBF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4893,
    stopColor: "#FFF8EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_154_1950",
    x1: 24.9998,
    y1: 43.3726,
    x2: 24.9998,
    y2: 48.1604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2DE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2223,
    stopColor: "#FFEDD7",
    stopOpacity: 0.222
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5516,
    stopColor: "#FFDFC3",
    stopOpacity: 0.552
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9456,
    stopColor: "#FFC8A2",
    stopOpacity: 0.946
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC49D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_154_1950",
    x1: 30.5169,
    y1: 44.1636,
    x2: 33.9771,
    y2: 46.8163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2DE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2223,
    stopColor: "#FFEDD7",
    stopOpacity: 0.222
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5516,
    stopColor: "#FFDFC3",
    stopOpacity: 0.552
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9456,
    stopColor: "#FFC8A2",
    stopOpacity: 0.946
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC49D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_154_1950",
    x1: 22.4689,
    y1: 27.4365,
    x2: 32.4047,
    y2: 42.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFBF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4893,
    stopColor: "#FFF8EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_154_1950",
    x1: 25,
    y1: 36.0533,
    x2: 25,
    y2: 45.6719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2DE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2223,
    stopColor: "#FFEDD7",
    stopOpacity: 0.222
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5516,
    stopColor: "#FFDFC3",
    stopOpacity: 0.552
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9456,
    stopColor: "#FFC8A2",
    stopOpacity: 0.946
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC49D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_154_1950",
    x1: 36.0832,
    y1: 37.6423,
    x2: 43.0344,
    y2: 42.9715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2DE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2223,
    stopColor: "#FFEDD7",
    stopOpacity: 0.222
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5516,
    stopColor: "#FFDFC3",
    stopOpacity: 0.552
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9456,
    stopColor: "#FFC8A2",
    stopOpacity: 0.946
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC49D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_154_1950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalad2);
export default __webpack_public_path__ + "static/media/salad 2.17eb0d14125dbf5862b9cddd16b754fe.svg";
export { ForwardRef as ReactComponent };